import React, { useState, useEffect } from "react";
import "./AdminPanel.css";

function AdminPanel() {
  const [personnel, setPersonnel] = useState([]);
  const [dutyHistory, setDutyHistory] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [chuttiGairHazir, setChuttiGairHazir] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [showPersonnelForm, setShowPersonnelForm] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showDutyHistoryForm, setShowDutyHistoryForm] = useState(false);
  const [showLeaveForm, setShowLeaveForm] = useState(false);
  const [showChuttiGairHazirForm, setShowChuttiGairHazirForm] = useState(false);
  
  const [editingPersonnel, setEditingPersonnel] = useState(null);
  const [activeTab, setActiveTab] = useState('personnel');
  
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [updateImage, setUpdateImage] = useState(null);
  const [updateImagePreview, setUpdateImagePreview] = useState(null);
  
  // Search state
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const [suspensionHistory, setSuspensionHistory] = useState([]);
const [showSuspensionForm, setShowSuspensionForm] = useState(false);
const [suspensionForm, setSuspensionForm] = useState({
  personnel_id: "", reason: "", suspended_from: "", suspended_until: ""
});

  
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  
  const dutyCategories = {
    "Fixed Duties": [
      "Mahanubhav/ Gawah Suraksha Duty",
      "Gunner Duty",
      "Mahanubhav Escort Duty",
      "VVIP/ Shok Salami Guard",
      "Bandi Medical Suraksha Guard",
      "VIP/ VVIP Suraksha Duty",
      "Adhikari Awaas Picket Duty",
      "Ratri Pehra Duty",
      "Stamp Paper Suraksha Duty",
      "EVM Suraksha Duty",
      "Paper/ Answer Booklet Suraksha Duty",
      "Quarter Guard Suraksha Duty"
    ],
    "Dynamic Duties": [
      "Hawalat Duty",
      "Hawalat QRT",
      "Kishor Peshi",
      "Kishor Medical",
      "Bandi Medical Prakshisharan",
      "Bandi Sthantharan",
      "Sanwasini Praiksha Duty",
      "Sanwasini Janpad/ Gair Janpad/ Gair Rajya Sthantharan",
      "Gair Janpad/ Gair Rajya Kaman",
      "Parivaar Paramarsh Kendra Duty",
      "Madad Mariz Duty",
      "VIP/ VVIP Escort Duty",
      "Shanti Vyavastha Duty",
      "Vibhinn Prakar Mela Duty",
      "Andar Janpad/ Gair Janpad/ Anya Rajya Khajana Suraksha Duty",
      "Andar Janpad/ Gair Janpad/ Gair Rajya Vishesh Vahak Duty",
      "Vibhinn Prakar Pariksha Duty",
      "Vibhinn Prakar Chunav Duty"
    ],
    "Others": []
  };

  const [personnelForm, setPersonnelForm] = useState({
    pno_no: "", name: "", rank: "", police_station: "",
    contact_number: "", joining_date: "", duty_type: "",
    duty_assignment: "", status: "active", custom_duty: "",
    description: "" 
  });

  const [dutyHistoryForm, setDutyHistoryForm] = useState({
    personnel_id: "", duty_type: "", duty_assignment: "",
    location: "", start_date: "", end_date: "", remarks: "", custom_duty: ""
  });

  const [leaveForm, setLeaveForm] = useState({
    personnel_id: "", leave_type: "casual", start_date: "", end_date: "",
    reason: "", status: "pending", remarks: ""
  });

  const [chuttiGairHazirForm, setChuttiGairHazirForm] = useState({
    personnel_id: "", start_date: "", end_date: "", reason: "", status: "pending"
  });

  useEffect(() => {
    fetchPersonnel();
    fetchDutyHistory();
    fetchLeaves();
    fetchChuttiGairHazir();
    fetchSuspensionHistory();
  }, []);

  // Search function
  const handleSearch = async () => {
    if (!searchTerm.trim()) {
      setIsSearching(false);
      setSearchResults([]);
      return;
    }

    try {
      setIsSearching(true);
      const response = await fetch(`${API_BASE_URL}/api/personnel/search?q=${encodeURIComponent(searchTerm)}`);
      if (!response.ok) throw new Error('Search failed');
      const data = await response.json();
      setSearchResults(data);
    } catch (err) {
      console.error('Search error:', err);
      // Fallback to client-side search if API fails
      const filtered = personnel.filter(p => 
        p.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.pno_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.rank?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.police_station?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setSearchResults(filtered);
    }
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchTerm("");
    setIsSearching(false);
    setSearchResults([]);
  };

  // Handle search input key press
  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const fetchPersonnel = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/personnel`);
      if (!response.ok) throw new Error('Failed to fetch personnel');
      const data = await response.json();
      setPersonnel(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching personnel:', err);
      setError('Failed to load personnel');
    } finally {
      setLoading(false);
    }
  };

  const fetchDutyHistory = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/duty-history`);
      if (!response.ok) throw new Error('Failed to fetch duty history');
      const data = await response.json();
      setDutyHistory(data);
    } catch (err) {
      console.error('Error fetching duty history:', err);
    }
  };

  const fetchLeaves = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/leave`);
      if (!response.ok) throw new Error('Failed to fetch leaves');
      const data = await response.json();
      setLeaves(data);
    } catch (err) {
      console.error('Error fetching leaves:', err);
    }
  };

  const fetchChuttiGairHazir = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/chutti-gair-hazir`);
      if (!response.ok) throw new Error('Failed to fetch chutti gair hazir');
      const data = await response.json();
      setChuttiGairHazir(data);
    } catch (err) {
      console.error('Error fetching chutti gair hazir:', err);
    }
  };

  const handleRefreshAll = async () => {
    try {
      setLoading(true);
      await Promise.all([
        fetchPersonnel(),
        fetchDutyHistory(),
        fetchLeaves(),
        fetchChuttiGairHazir(),
         fetchSuspensionHistory() 
      ]);
      alert('All data refreshed successfully!');
    } catch (err) {
      alert('Failed to refresh data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpdateImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUpdateImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setUpdateImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddPersonnel = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      
      // Determine final duty assignment
      let finalDutyAssignment = personnelForm.duty_assignment;
      if (personnelForm.duty_type === "Others" && personnelForm.custom_duty) {
        finalDutyAssignment = personnelForm.custom_duty;
      } else if (!finalDutyAssignment || finalDutyAssignment === "") {
        finalDutyAssignment = "Reserved";
      }
      
      Object.keys(personnelForm).forEach(key => {
        if (key !== 'custom_duty') {
          if (key === 'duty_assignment') {
            formData.append(key, finalDutyAssignment);
          } else {
            formData.append(key, personnelForm[key]);
          }
        }
      });
      
      if (selectedImage) {
        formData.append('image', selectedImage);
      }
      
      const response = await fetch(`${API_BASE_URL}/api/personnel`, {
        method: 'POST',
        body: formData,
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        alert(`Failed: ${errorData.message || 'Unknown error'}`);
        return;
      }
      
      alert('Personnel added successfully!');
      setPersonnelForm({
        pno_no: "", name: "", rank: "", police_station: "",
        contact_number: "", joining_date: "", duty_type: "",
        duty_assignment: "", status: "active", custom_duty: "",
        description: "" // ADD THIS LINE
      });
      setSelectedImage(null);
      setImagePreview(null);
      setShowPersonnelForm(false);
      fetchPersonnel();
    } catch (err) {
      console.error('Error:', err);
      alert('Failed to add personnel.');
    }
  };

  const handleUpdatePersonnel = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      
      // Determine final duty assignment
      let finalDutyAssignment = editingPersonnel.duty_assignment;
      if (editingPersonnel.duty_type === "Others" && editingPersonnel.custom_duty) {
        finalDutyAssignment = editingPersonnel.custom_duty;
      } else if (!finalDutyAssignment || finalDutyAssignment === "") {
        finalDutyAssignment = "Reserved";
      }

      // Get current personnel data to compare
      const currentPersonnel = personnel.find(p => p.id === editingPersonnel.id);
      const oldDutyAssignment = currentPersonnel?.duty_assignment;
      const oldDutyType = currentPersonnel?.duty_type;
      
      Object.keys(editingPersonnel).forEach(key => {
        if (key !== 'image_url' && key !== 'custom_duty') {
          if (key === 'duty_assignment') {
            formData.append(key, finalDutyAssignment);
          } else {
            formData.append(key, editingPersonnel[key]);
          }
        }
      });
      
      if (updateImage) {
        formData.append('image', updateImage);
      }
      
      const response = await fetch(`${API_BASE_URL}/api/personnel/${editingPersonnel.id}`, {
        method: 'PUT',
        body: formData,
      });
      
      if (!response.ok) throw new Error('Failed to update');
      
      // **ENHANCED DUTY HISTORY MANAGEMENT**
      if (oldDutyAssignment !== finalDutyAssignment) {
        try {
          const today = new Date().toISOString().split('T')[0];
          const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
          
          // 1. CLOSE THE PREVIOUS DUTY RECORD (if existed and wasn't Reserved)
          if (oldDutyAssignment && oldDutyAssignment !== "Reserved") {
            // Find active duty history records for this personnel
            const dutyHistoryResponse = await fetch(
              `${API_BASE_URL}/api/duty-history/personnel/${editingPersonnel.id}`
            );
            if (dutyHistoryResponse.ok) {
              const dutyHistory = await dutyHistoryResponse.json();
              
              // Find active records (without end date or future end date)
              const activeRecords = dutyHistory.filter(record => 
                !record.end_date || new Date(record.end_date) >= new Date()
              );
              
              // Close previous active records
              for (const record of activeRecords) {
                await fetch(`${API_BASE_URL}/api/duty-history/${record.id}`, {
                  method: 'PUT',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    ...record,
                    end_date: yesterday, // End yesterday
                    remarks: record.remarks ? 
                      `${record.remarks} | Duty changed on ${today}` : 
                      `Duty changed on ${today}`
                  })
                });
              }
            }
          }
          
          // 2. CREATE NEW DUTY HISTORY RECORD FOR CURRENT DUTY (if not Reserved)
          if (finalDutyAssignment && finalDutyAssignment !== "Reserved") {
            const dutyHistoryData = {
              personnel_id: editingPersonnel.id,
              duty_type: editingPersonnel.duty_type || "Fixed Duties",
              duty_assignment: finalDutyAssignment,
              start_date: today,
              end_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
              location: editingPersonnel.police_station || "",
              remarks: `Duty assignment: ${oldDutyAssignment || "Reserved"} → ${finalDutyAssignment}`
            };

            await fetch(`${API_BASE_URL}/api/duty-history`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(dutyHistoryData),
            });
          }
          
        } catch (historyErr) {
          console.error('Failed to update duty history records:', historyErr);
          // Don't fail the main update if history update fails
        }
      }
      
      alert('Updated successfully with duty history maintained!');
      setShowUpdateForm(false);
      setEditingPersonnel(null);
      setUpdateImage(null);
      setUpdateImagePreview(null);
      fetchPersonnel();
      fetchDutyHistory(); // Refresh duty history
    } catch (err) {
      alert('Failed to update personnel.');
    }
  };

  const handleDeletePersonnel = async (id) => {
    if (!window.confirm('Delete this personnel?')) return;
    try {
      const response = await fetch(`${API_BASE_URL}/api/personnel/${id}`, { method: 'DELETE' });
      if (!response.ok) throw new Error('Failed');
      alert('Deleted successfully!');
      setShowUpdateForm(false);
      setEditingPersonnel(null);
      fetchPersonnel();
    } catch (err) {
      alert('Failed to delete.');
    }
  };

  const handleAddDutyHistory = async (e) => {
    e.preventDefault();
    try {
      // Determine final duty assignment
      let finalDutyAssignment = dutyHistoryForm.duty_assignment;
      if (dutyHistoryForm.duty_type === "Others" && dutyHistoryForm.custom_duty) {
        finalDutyAssignment = dutyHistoryForm.custom_duty;
      }

      const dataToSend = {
        personnel_id: dutyHistoryForm.personnel_id,
        duty_type: dutyHistoryForm.duty_type,
        duty_assignment: finalDutyAssignment,
        location: dutyHistoryForm.location,
        start_date: dutyHistoryForm.start_date,
        end_date: dutyHistoryForm.end_date,
        remarks: dutyHistoryForm.remarks
      };

      const response = await fetch(`${API_BASE_URL}/api/duty-history`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataToSend),
      });
      if (!response.ok) {
        const errorData = await response.json();
        alert(`Failed: ${errorData.message}`);
        return;
      }
      alert('Duty history added!');
      setDutyHistoryForm({
        personnel_id: "", duty_type: "", duty_assignment: "",
        location: "", start_date: "", end_date: "", remarks: "", custom_duty: ""
      });
      setShowDutyHistoryForm(false);
      fetchDutyHistory();
    } catch (err) {
      alert('Failed to add duty history.');
    }
  };

  const handleDeleteDutyHistory = async (id) => {
    if (!window.confirm('Delete this duty history?')) return;
    try {
      await fetch(`${API_BASE_URL}/api/duty-history/${id}`, { method: 'DELETE' });
      alert('Deleted!');
      fetchDutyHistory();
    } catch (err) {
      alert('Failed to delete.');
    }
  };

  const handleAddLeave = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/api/leave`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(leaveForm),
      });
      if (!response.ok) {
        const errorData = await response.json();
        alert(`Failed: ${errorData.message}`);
        return;
      }
      alert('Leave added!');
      setLeaveForm({
        personnel_id: "", leave_type: "casual", start_date: "", end_date: "",
        reason: "", status: "pending", remarks: ""
      });
      setShowLeaveForm(false);
      fetchLeaves();
    } catch (err) {
      alert('Failed to add leave.');
    }
  };

  const handleDeleteLeave = async (id) => {
    if (!window.confirm('Delete this leave?')) return;
    try {
      await fetch(`${API_BASE_URL}/api/leave/${id}`, { method: 'DELETE' });
      alert('Deleted!');
      fetchLeaves();
    } catch (err) {
      alert('Failed to delete.');
    }
  };

  const handleApproveLeave = async (id) => {
    try {
      await fetch(`${API_BASE_URL}/api/leave/${id}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'approved', approved_by: 1, remarks: 'Approved' }),
      });
      alert('Leave approved!');
      fetchLeaves();
    } catch (err) {
      alert('Failed to approve.');
    }
  };

  const handleRejectLeave = async (id) => {
    const remarks = prompt('Enter rejection reason:');
    if (!remarks) return;
    try {
      await fetch(`${API_BASE_URL}/api/leave/${id}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: 'rejected', approved_by: 1, remarks }),
      });
      alert('Leave rejected!');
      fetchLeaves();
    } catch (err) {
      alert('Failed to reject.');
    }
  };

  // Chutti Gair Hazir Functions
  const handleAddChuttiGairHazir = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/api/chutti-gair-hazir`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(chuttiGairHazirForm),
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        alert(`Failed: ${errorData.message}`);
        return;
      }
      
      alert('Chutti se Gair Hazir record added successfully!');
      setChuttiGairHazirForm({
        personnel_id: "", start_date: "", end_date: "", reason: "", status: "pending"
      });
      setShowChuttiGairHazirForm(false);
      fetchChuttiGairHazir();
    } catch (err) {
      console.error('Error:', err);
      alert('Failed to add chutti gair hazir record.');
    }
  };

  const handleDeleteChuttiGairHazir = async (id) => {
    if (!window.confirm('Delete this chutti gair hazir record?')) return;
    try {
      const response = await fetch(`${API_BASE_URL}/api/chutti-gair-hazir/${id}`, { method: 'DELETE' });
      if (!response.ok) throw new Error('Failed');
      alert('Deleted successfully!');
      fetchChuttiGairHazir();
    } catch (err) {
      alert('Failed to delete.');
    }
  };

  const handleApproveChuttiGairHazir = async (id) => {
    const remarks = prompt('Enter approval remarks (optional):') || 'Approved';
    try {
      const response = await fetch(`${API_BASE_URL}/api/chutti-gair-hazir/${id}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          status: 'approved', 
          approved_by: 1, 
          remarks 
        }),
      });
      
      if (!response.ok) throw new Error('Failed to approve');
      
      alert('Chutti Gair Hazir approved!');
      fetchChuttiGairHazir();
    } catch (err) {
      alert('Failed to approve.');
    }
  };

  const handleRejectChuttiGairHazir = async (id) => {
    const remarks = prompt('Enter rejection reason:');
    if (!remarks) return;
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/chutti-gair-hazir/${id}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          status: 'rejected', 
          approved_by: 1, 
          remarks 
        }),
      });
      
      if (!response.ok) throw new Error('Failed to reject');
      
      alert('Chutti Gair Hazir rejected!');
      fetchChuttiGairHazir();
    } catch (err) {
      alert('Failed to reject.');
    }
  };

  // 3. Add fetchSuspensionHistory function
const fetchSuspensionHistory = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/suspension-history`);
    if (!response.ok) throw new Error('Failed to fetch suspension history');
    const data = await response.json();
    setSuspensionHistory(data);
  } catch (err) {
    console.error('Error fetching suspension history:', err);
  }
};

// 6. Add suspension management functions
const handleSuspendPersonnel = async (personnelId) => {
  const reason = prompt('Enter suspension reason:');
  if (!reason) return;

  const suspendedFrom = prompt('Suspension start date (YYYY-MM-DD):', new Date().toISOString().split('T')[0]);
  if (!suspendedFrom) return;

  const suspendedUntil = prompt('Suspension end date (YYYY-MM-DD) - Leave empty for indefinite:', '');

  try {
    // Update personnel status to suspended
    const personnelData = personnel.find(p => p.id === personnelId);
    const formData = new FormData();
    Object.keys(personnelData).forEach(key => {
      if (key !== 'image_url') {
        formData.append(key, personnelData[key]);
      }
    });
    formData.set('status', 'suspended');

    const updateResponse = await fetch(`${API_BASE_URL}/api/personnel/${personnelId}`, {
      method: 'PUT',
      body: formData,
    });

    if (!updateResponse.ok) throw new Error('Failed to update personnel status');

    // Create suspension history record
    const suspensionData = {
      personnel_id: personnelId,
      reason: reason,
      suspended_from: suspendedFrom,
      suspended_until: suspendedUntil || null,
      status: 'active'
    };

    const historyResponse = await fetch(`${API_BASE_URL}/api/suspension-history`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(suspensionData),
    });

    if (!historyResponse.ok) throw new Error('Failed to create suspension record');

    alert('Personnel suspended successfully!');
    fetchPersonnel();
    fetchSuspensionHistory();
  } catch (err) {
    console.error('Error:', err);
    alert('Failed to suspend personnel.');
  }
};

const handleUnsuspendPersonnel = async (personnelId) => {
  if (!window.confirm('Are you sure you want to remove suspension?')) return;

  try {
    // Update personnel status to active
    const personnelData = personnel.find(p => p.id === personnelId);
    const formData = new FormData();
    Object.keys(personnelData).forEach(key => {
      if (key !== 'image_url') {
        formData.append(key, personnelData[key]);
      }
    });
    formData.set('status', 'active');

    const updateResponse = await fetch(`${API_BASE_URL}/api/personnel/${personnelId}`, {
      method: 'PUT',
      body: formData,
    });

    if (!updateResponse.ok) throw new Error('Failed to update personnel status');

    // Close active suspension records
    const activeSuspensions = suspensionHistory.filter(
      s => s.personnel_id === personnelId && s.status === 'active'
    );

    for (const suspension of activeSuspensions) {
      await fetch(`${API_BASE_URL}/api/suspension-history/${suspension.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...suspension,
          suspended_until: new Date().toISOString().split('T')[0],
          status: 'completed'
        }),
      });
    }

    alert('Suspension removed successfully!');
    fetchPersonnel();
    fetchSuspensionHistory();
  } catch (err) {
    console.error('Error:', err);
    alert('Failed to remove suspension.');
  }
};

const handleDeleteSuspensionHistory = async (id) => {
  if (!window.confirm('Delete this suspension record?')) return;
  try {
    await fetch(`${API_BASE_URL}/api/suspension-history/${id}`, { method: 'DELETE' });
    alert('Deleted!');
    fetchSuspensionHistory();
  } catch (err) {
    alert('Failed to delete.');
  }
};

  const ranks = ["SSP", "SP", "Additional SP", 
    "Deputy SP", "Inspector", "Sub-Inspector", "ASI", "Head Constable", "Constable"];
  const dutyTypes = ["Fixed Duties", "Dynamic Duties", "Others"];
  const statuses = ["active", "on-leave", "transferred", "retired", "suspended"];
  const leaveTypes = ["Casual(CL)", "Medical(ML)", "Earned(EL)", "Child Care Leave(CCL)", "Maternity", "Rewarded Leave(RL)"];
  const leaveStatuses = ["pending", "approved", "rejected"];
  const chuttiGairHazirStatuses = ["pending", "approved", "rejected"];

  const getDutyAssignments = (dutyType) => {
    if (dutyType === "Others") {
      return [];
    }
    return dutyCategories[dutyType] || [];
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  // Data to display based on search state
  const displayPersonnel = isSearching ? searchResults : personnel;
  const displayDutyHistory = isSearching 
    ? dutyHistory.filter(record => 
        searchResults.some(person => person.id === record.personnel_id))
    : dutyHistory;
  const displayLeaves = isSearching
    ? leaves.filter(leave =>
        searchResults.some(person => person.id === leave.personnel_id))
    : leaves;
  const displayChuttiGairHazir = isSearching
    ? chuttiGairHazir.filter(record =>
        searchResults.some(person => person.id === record.personnel_id))
    : chuttiGairHazir;

  if (loading && personnel.length === 0) {
    return (
      <div className="admin-container">
        <div className="loading-spinner"><p>Loading...</p></div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <h1 className="admin-header">👮 Admin Panel - Management System</h1>
      
      {/* Search Section */}
      <div className="search-section">
        <div className="search-container">
          <input 
            type="text" 
            placeholder="Search by PNO number, name, rank, or police station..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={handleSearchKeyPress}
            className="search-input"
          />
          <button 
            className="btn btn-primary search-btn"
            onClick={handleSearch}
            disabled={!searchTerm.trim()}
          >
            🔍 Search
          </button>
          {isSearching && (
            <button 
              className="btn btn-secondary clear-search-btn"
              onClick={handleClearSearch}
            >
              ✖ Clear
            </button>
          )}
        </div>
        {isSearching && (
          <div className="search-info">
            <span className="search-results-count">
              Found {searchResults.length} result(s) for "{searchTerm}"
            </span>
          </div>
        )}
      </div>
      
      <div className="admin-tabs-container">
        <div className="admin-tabs">
          <button className={`tab-btn ${activeTab === 'personnel' ? 'active' : ''}`}
            onClick={() => setActiveTab('personnel')}>👥 Personnel</button>
          <button className={`tab-btn ${activeTab === 'duty-history' ? 'active' : ''}`}
            onClick={() => setActiveTab('duty-history')}>📋 Duty History</button>
          <button className={`tab-btn ${activeTab === 'leaves' ? 'active' : ''}`}
            onClick={() => setActiveTab('leaves')}>🏖️ Leaves</button>
          <button className={`tab-btn ${activeTab === 'chutti-gair-hazir' ? 'active' : ''}`}
            onClick={() => setActiveTab('chutti-gair-hazir')}>📝 Chutti Gair Hazir</button>
          <button className={`tab-btn ${activeTab === 'suspension' ? 'active' : ''}`}
  onClick={() => setActiveTab('suspension')}>🚫 Suspension</button>
        </div>
        <button 
          className="btn btn-refresh-top" 
          onClick={handleRefreshAll}
          disabled={loading}
        >
          {loading ? '⟳ Refreshing...' : '🔄 Refresh All'}
        </button>
      </div>

      <div className="admin-sections">
        {activeTab === 'personnel' && (
          <div className="quarter-section">
            <div className="section-header">
              <h2>Personnel Management {isSearching && `(Search Results: ${displayPersonnel.length})`}</h2>
              <div className="header-buttons">
                <button className="btn btn-primary"
                  onClick={() => { setShowPersonnelForm(!showPersonnelForm); setShowUpdateForm(false); }}>
                  {showPersonnelForm ? '✖ Cancel' : '+ Add Personnel'}
                </button>
                <button className="btn btn-secondary"
                  onClick={() => { setShowUpdateForm(!showUpdateForm); setShowPersonnelForm(false); }}>
                  {showUpdateForm ? '✖ Cancel' : '✏️ Update'}
                </button>
              </div>
            </div>

            {showPersonnelForm && (
              <div className="update-quarter-form">
                <h3>➕ Add Personnel</h3>
                <form onSubmit={handleAddPersonnel}>
                  <div className="form-grid">
                    <div className="form-group">
                      <label>PNO Number *</label>
                      <input placeholder="PNO001" value={personnelForm.pno_no}
                        onChange={(e) => setPersonnelForm({...personnelForm, pno_no: e.target.value})} required />
                    </div>
                    <div className="form-group">
                      <label>Name *</label>
                      <input placeholder="Full name" value={personnelForm.name}
                        onChange={(e) => setPersonnelForm({...personnelForm, name: e.target.value})} required />
                    </div>
                    <div className="form-group">
                      <label>Rank *</label>
                      <select value={personnelForm.rank}
                        onChange={(e) => setPersonnelForm({...personnelForm, rank: e.target.value})} required>
                        <option value="">Select</option>
                        {ranks.map(r => <option key={r} value={r}>{r}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Police Station</label>
                      <input placeholder="Hazratganj" value={personnelForm.police_station}
                        onChange={(e) => setPersonnelForm({...personnelForm, police_station: e.target.value})} />
                    </div>
                    <div className="form-group">
                      <label>Contact</label>
                      <input placeholder="10-digit" maxLength="10" value={personnelForm.contact_number}
                        onChange={(e) => setPersonnelForm({...personnelForm, contact_number: e.target.value})} />
                    </div>
                    <div className="form-group">
                      <label>Allotment Date</label>
                      <input type="date" value={personnelForm.joining_date}
                        onChange={(e) => setPersonnelForm({...personnelForm, joining_date: e.target.value})} />
                    </div>
                    <div className="form-group">
                      <label>Duty Type</label>
                      <select value={personnelForm.duty_type}
                        onChange={(e) => setPersonnelForm({...personnelForm, duty_type: e.target.value, duty_assignment: "", custom_duty: ""})}>
                        <option value="">Select (Optional)</option>
                        {dutyTypes.map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>
                    {personnelForm.duty_type && personnelForm.duty_type !== "Others" && (
                      <div className="form-group">
                        <label>Duty Assignment</label>
                        <select value={personnelForm.duty_assignment}
                          onChange={(e) => setPersonnelForm({...personnelForm, duty_assignment: e.target.value})}>
                          <option value="">Select (Optional - Will be Reserved)</option>
                          {getDutyAssignments(personnelForm.duty_type).map(d => (
                            <option key={d} value={d}>{d}</option>
                          ))}
                        </select>
                      </div>
                    )}
                    {personnelForm.duty_type === "Others" && (
                      <div className="form-group">
                        <label>Custom Duty Type</label>
                        <input 
                          placeholder="Enter custom duty type" 
                          value={personnelForm.custom_duty}
                          onChange={(e) => setPersonnelForm({...personnelForm, custom_duty: e.target.value})} 
                        />
                      </div>
                    )}
                    <div className="form-group">
                      <label>Status *</label>
                      <select value={personnelForm.status}
                        onChange={(e) => setPersonnelForm({...personnelForm, status: e.target.value})} required>
                        {statuses.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                    <div className="form-group" style={{gridColumn: '1/-1'}}>
                      <label>Personnel Photo</label>
                      <input 
                        type="file" 
                        accept="image/*"
                        onChange={handleImageChange}
                        className="file-input"
                      />
                      {imagePreview && (
                        <div className="image-preview-container">
                          <img src={imagePreview} alt="Preview" className="image-preview" />
                          <button 
                            type="button" 
                            className="btn btn-secondary"
                            onClick={() => {
                              setSelectedImage(null);
                              setImagePreview(null);
                            }}
                          >
                            ✖ Remove Image
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="form-group" style={{gridColumn: '1/-1'}}>
  <label>Description</label>
  <textarea 
    placeholder="Enter personnel description, background, special skills, or notes..." 
    value={personnelForm.description}
    onChange={(e) => setPersonnelForm({...personnelForm, description: e.target.value})} 
    rows={4}
    style={{
      width: '100%',
      padding: '10px',
      borderRadius: '8px',
      border: '1px solid #d1d5db',
      fontSize: '1rem',
      fontFamily: 'inherit',
      resize: 'vertical'
    }}
  />
  <small style={{color: '#6b7280', fontSize: '0.85rem'}}>
    This description will be visible in the dashboard personnel details
  </small>
</div>

                  </div>
                  <div className="form-actions">
                    <button type="submit" className="btn btn-primary">✓ Add</button>
                  </div>
                </form>
              </div>
            )}

            {showUpdateForm && (
              <div className="update-quarter-form">
                <h3>✏️ Update Personnel</h3>
                <form onSubmit={handleUpdatePersonnel}>
                  <div className="form-group">
                    <label>Select Personnel *</label>
                    <select value={editingPersonnel?.id || ""}
                      onChange={(e) => {
                        const p = personnel.find(x => x.id === parseInt(e.target.value));
                        if (p) {
                          setEditingPersonnel({...p, joining_date: p.joining_date?.split('T')[0], custom_duty: ""});
                          setUpdateImagePreview(p.image_url ? `${API_BASE_URL}${p.image_url}` : null);
                        }
                      }} required>
                      <option value="">-- Select --</option>
                      {personnel.map(p => (
                        <option key={p.id} value={p.id}>{p.name} ({p.pno_no})</option>
                      ))}
                    </select>
                  </div>
                  {editingPersonnel && (
                    <>
                      <div className="form-grid">
                        <div className="form-group">
                          <label>PNO *</label>
                          <input value={editingPersonnel.pno_no}
                            onChange={(e) => setEditingPersonnel({...editingPersonnel, pno_no: e.target.value})} required />
                        </div>
                        <div className="form-group">
                          <label>Name *</label>
                          <input value={editingPersonnel.name}
                            onChange={(e) => setEditingPersonnel({...editingPersonnel, name: e.target.value})} required />
                        </div>
                        <div className="form-group">
                          <label>Rank *</label>
                          <select value={editingPersonnel.rank}
                            onChange={(e) => setEditingPersonnel({...editingPersonnel, rank: e.target.value})} required>
                            {ranks.map(r => <option key={r} value={r}>{r}</option>)}
                          </select>
                        </div>
                        <div className="form-group">
                          <label>Police Station</label>
                          <input value={editingPersonnel.police_station || ""}
                            onChange={(e) => setEditingPersonnel({...editingPersonnel, police_station: e.target.value})} />
                        </div>
                        <div className="form-group">
                          <label>Contact</label>
                          <input value={editingPersonnel.contact_number || ""}
                            onChange={(e) => setEditingPersonnel({...editingPersonnel, contact_number: e.target.value})} />
                        </div>
                        <div className="form-group">
                          <label>Duty Type</label>
                          <select value={editingPersonnel.duty_type || ""}
                            onChange={(e) => setEditingPersonnel({...editingPersonnel, duty_type: e.target.value, duty_assignment: "", custom_duty: ""})}>
                            <option value="">Select (Optional)</option>
                            {dutyTypes.map(t => <option key={t} value={t}>{t}</option>)}
                          </select>
                        </div>
                        {editingPersonnel.duty_type && editingPersonnel.duty_type !== "Others" && (
                          <div className="form-group">
                            <label>Duty Assignment</label>
                            <select value={editingPersonnel.duty_assignment || ""}
                              onChange={(e) => setEditingPersonnel({...editingPersonnel, duty_assignment: e.target.value})}>
                              <option value="">Select (Optional - Will be Reserved)</option>
                              {getDutyAssignments(editingPersonnel.duty_type).map(d => (
                                <option key={d} value={d}>{d}</option>
                              ))}
                            </select>
                          </div>
                        )}
                        {editingPersonnel.duty_type === "Others" && (
                          <div className="form-group">
                            <label>Custom Duty Type</label>
                            <input 
                              placeholder="Enter custom duty type" 
                              value={editingPersonnel.custom_duty || editingPersonnel.duty_assignment || ""}
                              onChange={(e) => setEditingPersonnel({...editingPersonnel, custom_duty: e.target.value})} 
                            />
                          </div>
                        )}
                        <div className="form-group">
                          <label>Status *</label>
                          <select value={editingPersonnel.status}
                            onChange={(e) => setEditingPersonnel({...editingPersonnel, status: e.target.value})} required>
                            {statuses.map(s => <option key={s} value={s}>{s}</option>)}
                          </select>
                        </div>
                        <div className="form-group" style={{gridColumn: '1/-1'}}>
                          <label>Update Photo</label>
                          <input 
                            type="file" 
                            accept="image/*"
                            onChange={handleUpdateImageChange}
                            className="file-input"
                          />
                          {updateImagePreview && (
                            <div className="image-preview-container">
                              <img src={updateImagePreview} alt="Preview" className="image-preview" />
                              <button 
                                type="button" 
                                className="btn btn-secondary"
                                onClick={() => {
                                  setUpdateImage(null);
                                  setUpdateImagePreview(null);
                                }}
                              >
                                ✖ Remove Image
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="form-group" style={{gridColumn: '1/-1'}}>
  <label>Description</label>
  <textarea 
    placeholder="Enter personnel description, background, special skills, or notes..." 
    value={editingPersonnel.description || ""}
    onChange={(e) => setEditingPersonnel({...editingPersonnel, description: e.target.value})} 
    rows={4}
    style={{
      width: '100%',
      padding: '10px',
      borderRadius: '8px',
      border: '1px solid #d1d5db',
      fontSize: '1rem',
      fontFamily: 'inherit',
      resize: 'vertical'
    }}
  />
  <small style={{color: '#6b7280', fontSize: '0.85rem'}}>
    This description will be visible in the dashboard personnel details
  </small>
</div>
                      </div>
                      <div className="form-actions">
                        <button type="submit" className="btn btn-primary">✓ Update</button>
                        <button type="button" className="btn btn-danger"
                          onClick={() => handleDeletePersonnel(editingPersonnel.id)}>🗑️ Delete</button>
                      </div>
                    </>
                  )}
                </form>
              </div>
            )}

            <div className="repair-section">
              <h3>Personnel Directory ({displayPersonnel.length})</h3>
              {displayPersonnel.length === 0 ? (
                <div className="no-results">
                  <p>No personnel found {isSearching ? 'matching your search criteria' : ''}</p>
                </div>
              ) : (
                <div className="repair-list">
                  {displayPersonnel.map(p => (
                    <div key={p.id} className="repair-item">
                      {p.image_url && (
                        <div className="personnel-list-image">
                          <img 
                            src={`${API_BASE_URL}${p.image_url}`} 
                            alt={p.name}
                            onError={(e) => e.target.style.display = 'none'}
                          />
                        </div>
                      )}
                      <div className="repair-info">
                        <h4>👤 {p.name} <span className={`status-badge ${p.status}`}>{p.status}</span></h4>
                        <p><strong>PNO:</strong> {p.pno_no} | <strong>Rank:</strong> {p.rank}</p>
                        <p><strong>Duty:</strong> {p.duty_type || "N/A"} - {p.duty_assignment || "Reserved"}</p>
                      </div>
                      <button className="btn btn-secondary" onClick={() => {
                        setEditingPersonnel({...p, joining_date: p.joining_date?.split('T')[0], custom_duty: ""});
                        setUpdateImagePreview(p.image_url ? `${API_BASE_URL}${p.image_url}` : null);
                        setShowUpdateForm(true);
                        setShowPersonnelForm(false);
                      }}>✏️ Edit</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
        {/* Duty History Tab */}
        {activeTab === 'duty-history' && (
          <div className="quarter-section">
            <div className="section-header">
              <h2>Duty History {isSearching && `(Filtered: ${displayDutyHistory.length})`}</h2>
              <button className="btn btn-primary"
                onClick={() => setShowDutyHistoryForm(!showDutyHistoryForm)}>
                {showDutyHistoryForm ? '✖ Cancel' : '+ Add'}
              </button>
            </div>

            {showDutyHistoryForm && (
              <div className="update-quarter-form">
                <h3>➕ Add Duty History</h3>
                <form onSubmit={handleAddDutyHistory}>
                  <div className="form-grid">
                    <div className="form-group">
                      <label>Personnel *</label>
                      <select value={dutyHistoryForm.personnel_id}
                        onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, personnel_id: e.target.value})} required>
                        <option value="">-- Select --</option>
                        {personnel.map(p => <option key={p.id} value={p.id}>{p.name} ({p.pno_no})</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Duty Type *</label>
                      <select value={dutyHistoryForm.duty_type}
                        onChange={(e) => {
                          setDutyHistoryForm({
                            ...dutyHistoryForm, 
                            duty_type: e.target.value,
                            duty_assignment: getDutyAssignments(e.target.value)[0] // Reset to first duty of selected type
                          });
                        }} required>
                        {dutyTypes.map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Duty Assignment *</label>
                      <select value={dutyHistoryForm.duty_assignment}
                        onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, duty_assignment: e.target.value})} required>
                        {getDutyAssignments(dutyHistoryForm.duty_type).map(d => (
                          <option key={d} value={d}>{d}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Location</label>
                      <input placeholder="Police Station" value={dutyHistoryForm.location}
                        onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, location: e.target.value})} />
                    </div>
                    <div className="form-group">
                      <label>Start Date *</label>
                      <input type="date" value={dutyHistoryForm.start_date}
                        onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, start_date: e.target.value})} required />
                    </div>
                    <div className="form-group">
                      <label>End Date *</label>
                      <input type="date" value={dutyHistoryForm.end_date}
                        onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, end_date: e.target.value})} required />
                    </div>
                    <div className="form-group" style={{gridColumn: '1/-1'}}>
                      <label>Remarks</label>
                      <textarea placeholder="Notes..." value={dutyHistoryForm.remarks}
                        onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, remarks: e.target.value})} rows={3} />
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary">✓ Add</button>
                </form>
              </div>
            )}

            <div className="repair-section">
              <h3>Records ({displayDutyHistory.length})</h3>
              {displayDutyHistory.length === 0 ? (
                <div className="no-results">
                  <p>No duty history records found {isSearching ? 'matching your search criteria' : ''}</p>
                </div>
              ) : (
                <div className="repair-list">
                  {displayDutyHistory.map(r => (
                    <div key={r.id} className="repair-item">
                      <div className="repair-info">
                        <h4>📋 {r.name} ({r.pno_no})</h4>
                        <p><strong>Duty:</strong> {r.duty_type} - {r.duty_assignment}</p>
                        <p><strong>Period:</strong> {formatDate(r.start_date)} to {formatDate(r.end_date)}</p>
                        {r.location && <p><strong>Location:</strong> {r.location}</p>}
                        {r.remarks && <p><em>{r.remarks}</em></p>}
                      </div>
                      <button className="btn btn-danger" onClick={() => handleDeleteDutyHistory(r.id)}>🗑️</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Leaves Tab */}
        {activeTab === 'leaves' && (
          <div className="quarter-section">
            <div className="section-header">
              <h2>Leave Management {isSearching && `(Filtered: ${displayLeaves.length})`}</h2>
              <button className="btn btn-primary"
                onClick={() => setShowLeaveForm(!showLeaveForm)}>
                {showLeaveForm ? '✖ Cancel' : '+ Add'}
              </button>
            </div>

            {showLeaveForm && (
              <div className="update-quarter-form">
                <h3>➕ Add Leave</h3>
                <form onSubmit={handleAddLeave}>
                  <div className="form-grid">
                    <div className="form-group">
                      <label>Personnel *</label>
                      <select value={leaveForm.personnel_id}
                        onChange={(e) => setLeaveForm({...leaveForm, personnel_id: e.target.value})} required>
                        <option value="">-- Select --</option>
                        {personnel.map(p => <option key={p.id} value={p.id}>{p.name} ({p.pno_no})</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Leave Type *</label>
                      <select value={leaveForm.leave_type}
                        onChange={(e) => setLeaveForm({...leaveForm, leave_type: e.target.value})} required>
                        {leaveTypes.map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Start *</label>
                      <input type="date" value={leaveForm.start_date}
                        onChange={(e) => setLeaveForm({...leaveForm, start_date: e.target.value})} required />
                    </div>
                    <div className="form-group">
                      <label>End *</label>
                      <input type="date" value={leaveForm.end_date}
                        onChange={(e) => setLeaveForm({...leaveForm, end_date: e.target.value})} required />
                    </div>
                    <div className="form-group">
                      <label>Status *</label>
                      <select value={leaveForm.status}
                        onChange={(e) => setLeaveForm({...leaveForm, status: e.target.value})} required>
                        {leaveStatuses.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                    <div className="form-group" style={{gridColumn: '1/-1'}}>
                      <label>Reason *</label>
                      <textarea placeholder="Reason..." value={leaveForm.reason}
                        onChange={(e) => setLeaveForm({...leaveForm, reason: e.target.value})} required rows={3} />
                    </div>
                    <div className="form-group" style={{gridColumn: '1/-1'}}>
                      <label>Remarks</label>
                      <textarea placeholder="Admin remarks..." value={leaveForm.remarks}
                        onChange={(e) => setLeaveForm({...leaveForm, remarks: e.target.value})} rows={2} />
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary">✓ Add</button>
                </form>
              </div>
            )}

            <div className="repair-section">
              <h3>Leave Records ({displayLeaves.length})</h3>
              {displayLeaves.length === 0 ? (
                <div className="no-results">
                  <p>No leave records found {isSearching ? 'matching your search criteria' : ''}</p>
                </div>
              ) : (
                <div className="repair-list">
                  {displayLeaves.map(l => (
                    <div key={l.id} className="repair-item">
                      <div className="repair-info">
                        <h4>🏖️ {l.name} ({l.pno_no})</h4>
                        <p><strong>Type:</strong> {l.leave_type} | <span className={`status-badge ${l.status}`}>{l.status}</span></p>
                        <p><strong>Period:</strong> {formatDate(l.start_date)} to {formatDate(l.end_date)}</p>
                        <p><strong>Reason:</strong> {l.reason}</p>
                        {l.remarks && <p><em>Remarks: {l.remarks}</em></p>}
                      </div>
                      <div className="repair-actions">
                        {l.status === 'pending' && (
                          <>
                            <button className="btn btn-primary" onClick={() => handleApproveLeave(l.id)}>✓</button>
                            <button className="btn btn-secondary" onClick={() => handleRejectLeave(l.id)}>✖</button>
                          </>
                        )}
                        <button className="btn btn-danger" onClick={() => handleDeleteLeave(l.id)}>🗑️</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Chutti Gair Hazir Tab */}
        {activeTab === 'chutti-gair-hazir' && (
          <div className="quarter-section">
            <div className="section-header">
              <h2>Chutti Gair Hazir Management {isSearching && `(Filtered: ${displayChuttiGairHazir.length})`}</h2>
              <button className="btn btn-primary"
                onClick={() => setShowChuttiGairHazirForm(!showChuttiGairHazirForm)}>
                {showChuttiGairHazirForm ? '✖ Cancel' : '+ Add'}
              </button>
            </div>

            {showChuttiGairHazirForm && (
              <div className="update-quarter-form">
                <h3>➕ Add Chutti Gair Hazir Record</h3>
                <form onSubmit={handleAddChuttiGairHazir}>
                  <div className="form-grid">
                    <div className="form-group">
                      <label>Personnel *</label>
                      <select 
                        value={chuttiGairHazirForm.personnel_id}
                        onChange={(e) => setChuttiGairHazirForm({...chuttiGairHazirForm, personnel_id: e.target.value})} 
                        required
                      >
                        <option value="">-- Select --</option>
                        {personnel.map(p => (
                          <option key={p.id} value={p.id}>
                            {p.name} ({p.pno_no}) - {p.rank}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Start Date *</label>
                      <input 
                        type="date" 
                        value={chuttiGairHazirForm.start_date}
                        onChange={(e) => setChuttiGairHazirForm({...chuttiGairHazirForm, start_date: e.target.value})} 
                        required 
                      />
                    </div>
                    <div className="form-group">
                      <label>End Date *</label>
                      <input 
                        type="date" 
                        value={chuttiGairHazirForm.end_date}
                        onChange={(e) => setChuttiGairHazirForm({...chuttiGairHazirForm, end_date: e.target.value})} 
                        required 
                      />
                    </div>
                    <div className="form-group">
                      <label>Status *</label>
                      <select 
                        value={chuttiGairHazirForm.status}
                        onChange={(e) => setChuttiGairHazirForm({...chuttiGairHazirForm, status: e.target.value})} 
                        required
                      >
                        {chuttiGairHazirStatuses.map(s => (
                          <option key={s} value={s}>{s}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group" style={{gridColumn: '1/-1'}}>
                      <label>Reason *</label>
                      <textarea 
                        placeholder="Reason for being absent..." 
                        value={chuttiGairHazirForm.reason}
                        onChange={(e) => setChuttiGairHazirForm({...chuttiGairHazirForm, reason: e.target.value})} 
                        required 
                        rows={3} 
                      />
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary">✓ Add</button>
                </form>
              </div>
            )}

            <div className="repair-section">
              <h3>Chutti Gair Hazir Records ({displayChuttiGairHazir.length})</h3>
              {displayChuttiGairHazir.length === 0 ? (
                <div className="no-results">
                  <p>No chutti gair hazir records found {isSearching ? 'matching your search criteria' : ''}</p>
                </div>
              ) : (
                <div className="repair-list">
                  {displayChuttiGairHazir.map(record => (
                    <div key={record.id} className="repair-item">
                      <div className="repair-info">
                        <h4>📝 {record.name} ({record.pno_no})</h4>
                        <p><strong>Rank:</strong> {record.rank}</p>
                        <p><strong>Period:</strong> {formatDate(record.start_date)} to {formatDate(record.end_date)}</p>
                        <p><strong>Reason:</strong> {record.reason}</p>
                        <p><strong>Status:</strong> <span className={`status-badge ${record.status}`}>{record.status}</span></p>
                        {record.approved_by && (
                          <p><strong>Approved By:</strong> {record.approved_by}</p>
                        )}
                        {record.approval_date && (
                          <p><strong>Approval Date:</strong> {formatDate(record.approval_date)}</p>
                        )}
                        {record.remarks && (
                          <p><em>Remarks: {record.remarks}</em></p>
                        )}
                      </div>
                      <div className="repair-actions">
                        {record.status === 'pending' && (
                          <>
                            <button 
                              className="btn btn-primary" 
                              onClick={() => handleApproveChuttiGairHazir(record.id)}
                            >
                              ✓
                            </button>
                            <button 
                              className="btn btn-secondary" 
                              onClick={() => handleRejectChuttiGairHazir(record.id)}
                            >
                              ✖
                            </button>
                          </>
                        )}
                        <button 
                          className="btn btn-danger" 
                          onClick={() => handleDeleteChuttiGairHazir(record.id)}
                        >
                          🗑️
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
        {activeTab === 'suspension' && (
  <div className="quarter-section">
    <div className="section-header">
      <h2>Suspension Management {isSearching && `(Filtered)`}</h2>
    </div>

    <div className="repair-section">
      <h3>Suspended Personnel</h3>
      <div className="repair-list">
        {personnel.filter(p => p.status === 'suspended').length > 0 ? (
          personnel.filter(p => p.status === 'suspended').map(p => {
            const activeSuspension = suspensionHistory.find(
              s => s.personnel_id === p.id && s.status === 'active'
            );
            return (
              <div key={p.id} className="repair-item" style={{ borderLeft: '4px solid #dc2626', background: '#fee2e2' }}>
                {p.image_url && (
                  <div className="personnel-list-image">
                    <img 
                      src={`${API_BASE_URL}${p.image_url}`} 
                      alt={p.name}
                      onError={(e) => e.target.style.display = 'none'}
                    />
                  </div>
                )}
                <div className="repair-info">
                  <h4>🚫 {p.name} <span className="status-badge suspended">suspended</span></h4>
                  <p><strong>PNO:</strong> {p.pno_no} | <strong>Rank:</strong> {p.rank}</p>
                  {activeSuspension && (
                    <>
                      <p><strong>Suspended From:</strong> {formatDate(activeSuspension.suspended_from)}</p>
                      {activeSuspension.suspended_until && (
                        <p><strong>Until:</strong> {formatDate(activeSuspension.suspended_until)}</p>
                      )}
                      <p><strong>Reason:</strong> {activeSuspension.reason}</p>
                    </>
                  )}
                </div>
                <button 
                  className="btn btn-primary" 
                  onClick={() => handleUnsuspendPersonnel(p.id)}
                  style={{ background: '#16a34a' }}
                >
                  ✓ Remove Suspension
                </button>
              </div>
            );
          })
        ) : (
          <p className="no-data">No suspended personnel</p>
        )}
      </div>

      <div className="section-divider"></div>

      <h3>Active Personnel (Can Suspend)</h3>
      <div className="repair-list">
        {personnel.filter(p => p.status === 'active').map(p => (
          <div key={p.id} className="repair-item">
            {p.image_url && (
              <div className="personnel-list-image">
                <img 
                  src={`${API_BASE_URL}${p.image_url}`} 
                  alt={p.name}
                  onError={(e) => e.target.style.display = 'none'}
                />
              </div>
            )}
            <div className="repair-info">
              <h4>👤 {p.name} <span className="status-badge active">active</span></h4>
              <p><strong>PNO:</strong> {p.pno_no} | <strong>Rank:</strong> {p.rank}</p>
              <p><strong>Duty:</strong> {p.duty_type || "N/A"} - {p.duty_assignment || "Reserved"}</p>
            </div>
            <button 
              className="btn btn-danger" 
              onClick={() => handleSuspendPersonnel(p.id)}
            >
              🚫 Suspend
            </button>
          </div>
        ))}
      </div>

      <div className="section-divider"></div>

      <h3>Suspension History ({suspensionHistory.length})</h3>
      <div className="repair-list">
        {suspensionHistory.length > 0 ? (
          suspensionHistory.map(record => {
            const person = personnel.find(p => p.id === record.personnel_id);
            return (
              <div key={record.id} className="repair-item">
                <div className="repair-info">
                  <h4>📋 {person?.name || 'Unknown'} ({person?.pno_no || 'N/A'})</h4>
                  <p><strong>Period:</strong> {formatDate(record.suspended_from)} to {record.suspended_until ? formatDate(record.suspended_until) : 'Indefinite'}</p>
                  <p><strong>Reason:</strong> {record.reason}</p>
                  <p><strong>Status:</strong> <span className={`status-badge ${record.status}`}>{record.status}</span></p>
                  {record.remarks && <p><em>Remarks: {record.remarks}</em></p>}
                </div>
                <button 
                  className="btn btn-danger" 
                  onClick={() => handleDeleteSuspensionHistory(record.id)}
                >
                  🗑️
                </button>
              </div>
            );
          })
        ) : (
          <p className="no-data">No suspension history records</p>
        )}
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
}

export default AdminPanel;

// import React, { useState, useEffect } from "react";
// import "./AdminPanel.css";

// function AdminPanel() {
//   const [personnel, setPersonnel] = useState([]);
//   const [dutyHistory, setDutyHistory] = useState([]);
//   const [leaves, setLeaves] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  
//   const [showPersonnelForm, setShowPersonnelForm] = useState(false);
//   const [showUpdateForm, setShowUpdateForm] = useState(false);
//   const [showDutyHistoryForm, setShowDutyHistoryForm] = useState(false);
//   const [showLeaveForm, setShowLeaveForm] = useState(false);
  
//   const [editingPersonnel, setEditingPersonnel] = useState(null);
//   const [activeTab, setActiveTab] = useState('personnel');
  
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [updateImage, setUpdateImage] = useState(null);
//   const [updateImagePreview, setUpdateImagePreview] = useState(null);
  
//   // Search state
//   const [searchTerm, setSearchTerm] = useState("");
//   const [searchResults, setSearchResults] = useState([]);
//   const [isSearching, setIsSearching] = useState(false);
  
//   const API_BASE_URL = process.env.REACT_APP_API_URL;
  
//   const dutyCategories = {
//     "Fixed Duties": [
//       "General Duty",
//       "General Duty plus Art D",
//       "Field Duty",
//       "Field Medical",
//       "City Medical Patrol",
//       "City Establishment",
//       "Guard Janpad / State Post",
//       "Patrol Mobile DSP Wise",
//       "Mahanagar / City District Wise",
//       "Court Duty",
//       "Court Security Reserve Duty",
//       "VIP Duty / Rank Security Guard",
//       "VIP Duty / VIP Security Reserve Duty",
//       "City Line Position Duty",
//       "Financial Institution Duty",
//       "Different Flag Parade Duty",
//       "Criminality Affected Special Duty",
//       "Night Patrol Duty",
//       "Paper / Other Important Security Duty",
//       "Sampark Suraksha Duty",
//       "Different Flag Parade Duty (2)"
//     ],
//     "Dynamic Duties": [
//       "Law and Order Parade Duty",
//       "Law and Order Janpad / Guard Janpad / State Establishment",
//       "Court Security Duty",
//       "VIP Duty / VIP Accompanying Security Duty",
//       "Audit Janpad / State Janpad / Other State Visit Security Duty",
//       "Audit Janpad / State Janpad / State Special Escort Duty",
//       "Different Flag Election Duty",
//       "Svayam Gir Security Duty",
//       "Eidgah Security Duty"
//     ],
//     "Others": []
//   };

//   const [personnelForm, setPersonnelForm] = useState({
//     pno_no: "", name: "", rank: "", police_station: "",
//     contact_number: "", joining_date: "", duty_type: "",
//     duty_assignment: "", status: "active", custom_duty: ""
//   });

//   const [dutyHistoryForm, setDutyHistoryForm] = useState({
//     personnel_id: "", duty_type: "", duty_assignment: "",
//     location: "", start_date: "", end_date: "", remarks: "", custom_duty: ""
//   });

//   const [leaveForm, setLeaveForm] = useState({
//     personnel_id: "", leave_type: "casual", start_date: "", end_date: "",
//     reason: "", status: "pending", remarks: ""
//   });

//   useEffect(() => {
//     fetchPersonnel();
//     fetchDutyHistory();
//     fetchLeaves();
//   }, []);

//   // Search function
//   const handleSearch = async () => {
//     if (!searchTerm.trim()) {
//       setIsSearching(false);
//       setSearchResults([]);
//       return;
//     }

//     try {
//       setIsSearching(true);
//       const response = await fetch(`${API_BASE_URL}/api/personnel/search?q=${encodeURIComponent(searchTerm)}`);
//       if (!response.ok) throw new Error('Search failed');
//       const data = await response.json();
//       setSearchResults(data);
//     } catch (err) {
//       console.error('Search error:', err);
//       // Fallback to client-side search if API fails
//       const filtered = personnel.filter(p => 
//         p.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         p.pno_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         p.rank?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         p.police_station?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       setSearchResults(filtered);
//     }
//   };

//   // Clear search
//   const handleClearSearch = () => {
//     setSearchTerm("");
//     setIsSearching(false);
//     setSearchResults([]);
//   };

//   // Handle search input key press
//   const handleSearchKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleSearch();
//     }
//   };

//   const fetchPersonnel = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${API_BASE_URL}/api/personnel`);
//       if (!response.ok) throw new Error('Failed to fetch personnel');
//       const data = await response.json();
//       setPersonnel(data);
//       setError(null);
//     } catch (err) {
//       console.error('Error fetching personnel:', err);
//       setError('Failed to load personnel');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchDutyHistory = async () => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/duty-history`);
//       if (!response.ok) throw new Error('Failed to fetch duty history');
//       const data = await response.json();
//       setDutyHistory(data);
//     } catch (err) {
//       console.error('Error fetching duty history:', err);
//     }
//   };

//   const fetchLeaves = async () => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/leave`);
//       if (!response.ok) throw new Error('Failed to fetch leaves');
//       const data = await response.json();
//       setLeaves(data);
//     } catch (err) {
//       console.error('Error fetching leaves:', err);
//     }
//   };

//   const handleRefreshAll = async () => {
//     try {
//       setLoading(true);
//       await Promise.all([
//         fetchPersonnel(),
//         fetchDutyHistory(),
//         fetchLeaves()
//       ]);
//       alert('All data refreshed successfully!');
//     } catch (err) {
//       alert('Failed to refresh data. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setSelectedImage(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleUpdateImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setUpdateImage(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setUpdateImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleAddPersonnel = async (e) => {
//     e.preventDefault();
//     try {
//       const formData = new FormData();
      
//       // Determine final duty assignment
//       let finalDutyAssignment = personnelForm.duty_assignment;
//       if (personnelForm.duty_type === "Others" && personnelForm.custom_duty) {
//         finalDutyAssignment = personnelForm.custom_duty;
//       } else if (!finalDutyAssignment || finalDutyAssignment === "") {
//         finalDutyAssignment = "Reserved";
//       }
      
//       Object.keys(personnelForm).forEach(key => {
//         if (key !== 'custom_duty') {
//           if (key === 'duty_assignment') {
//             formData.append(key, finalDutyAssignment);
//           } else {
//             formData.append(key, personnelForm[key]);
//           }
//         }
//       });
      
//       if (selectedImage) {
//         formData.append('image', selectedImage);
//       }
      
//       const response = await fetch(`${API_BASE_URL}/api/personnel`, {
//         method: 'POST',
//         body: formData,
//       });
      
//       if (!response.ok) {
//         const errorData = await response.json();
//         alert(`Failed: ${errorData.message || 'Unknown error'}`);
//         return;
//       }
      
//       alert('Personnel added successfully!');
//       setPersonnelForm({
//         pno_no: "", name: "", rank: "", police_station: "",
//         contact_number: "", joining_date: "", duty_type: "",
//         duty_assignment: "", status: "active", custom_duty: ""
//       });
//       setSelectedImage(null);
//       setImagePreview(null);
//       setShowPersonnelForm(false);
//       fetchPersonnel();
//     } catch (err) {
//       console.error('Error:', err);
//       alert('Failed to add personnel.');
//     }
//   };

//   const handleUpdatePersonnel = async (e) => {
//     e.preventDefault();
//     try {
//       const formData = new FormData();
      
//       // Determine final duty assignment
//       let finalDutyAssignment = editingPersonnel.duty_assignment;
//       if (editingPersonnel.duty_type === "Others" && editingPersonnel.custom_duty) {
//         finalDutyAssignment = editingPersonnel.custom_duty;
//       } else if (!finalDutyAssignment || finalDutyAssignment === "") {
//         finalDutyAssignment = "Reserved";
//       }

//       // Get current personnel data to compare
//       const currentPersonnel = personnel.find(p => p.id === editingPersonnel.id);
//       const oldDutyAssignment = currentPersonnel?.duty_assignment;
//       const oldDutyType = currentPersonnel?.duty_type;
      
//       Object.keys(editingPersonnel).forEach(key => {
//         if (key !== 'image_url' && key !== 'custom_duty') {
//           if (key === 'duty_assignment') {
//             formData.append(key, finalDutyAssignment);
//           } else {
//             formData.append(key, editingPersonnel[key]);
//           }
//         }
//       });
      
//       if (updateImage) {
//         formData.append('image', updateImage);
//       }
      
//       const response = await fetch(`${API_BASE_URL}/api/personnel/${editingPersonnel.id}`, {
//         method: 'PUT',
//         body: formData,
//       });
      
//       if (!response.ok) throw new Error('Failed to update');
      
//       // **ENHANCED DUTY HISTORY MANAGEMENT**
//       if (oldDutyAssignment !== finalDutyAssignment) {
//         try {
//           const today = new Date().toISOString().split('T')[0];
//           const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
          
//           // 1. CLOSE THE PREVIOUS DUTY RECORD (if existed and wasn't Reserved)
//           if (oldDutyAssignment && oldDutyAssignment !== "Reserved") {
//             // Find active duty history records for this personnel
//             const dutyHistoryResponse = await fetch(
//               `${API_BASE_URL}/api/duty-history/personnel/${editingPersonnel.id}`
//             );
//             if (dutyHistoryResponse.ok) {
//               const dutyHistory = await dutyHistoryResponse.json();
              
//               // Find active records (without end date or future end date)
//               const activeRecords = dutyHistory.filter(record => 
//                 !record.end_date || new Date(record.end_date) >= new Date()
//               );
              
//               // Close previous active records
//               for (const record of activeRecords) {
//                 await fetch(`${API_BASE_URL}/api/duty-history/${record.id}`, {
//                   method: 'PUT',
//                   headers: { 'Content-Type': 'application/json' },
//                   body: JSON.stringify({
//                     ...record,
//                     end_date: yesterday, // End yesterday
//                     remarks: record.remarks ? 
//                       `${record.remarks} | Duty changed on ${today}` : 
//                       `Duty changed on ${today}`
//                   })
//                 });
//               }
//             }
//           }
          
//           // 2. CREATE NEW DUTY HISTORY RECORD FOR CURRENT DUTY (if not Reserved)
//           if (finalDutyAssignment && finalDutyAssignment !== "Reserved") {
//             const dutyHistoryData = {
//               personnel_id: editingPersonnel.id,
//               duty_type: editingPersonnel.duty_type || "Fixed Duties",
//               duty_assignment: finalDutyAssignment,
//               start_date: today,
//               end_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
//               location: editingPersonnel.police_station || "",
//               remarks: `Duty assignment: ${oldDutyAssignment || "Reserved"} → ${finalDutyAssignment}`
//             };

//             await fetch(`${API_BASE_URL}/api/duty-history`, {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify(dutyHistoryData),
//             });
//           }
          
//         } catch (historyErr) {
//           console.error('Failed to update duty history records:', historyErr);
//           // Don't fail the main update if history update fails
//         }
//       }
      
//       alert('Updated successfully with duty history maintained!');
//       setShowUpdateForm(false);
//       setEditingPersonnel(null);
//       setUpdateImage(null);
//       setUpdateImagePreview(null);
//       fetchPersonnel();
//       fetchDutyHistory(); // Refresh duty history
//     } catch (err) {
//       alert('Failed to update personnel.');
//     }
//   };

//   const handleDeletePersonnel = async (id) => {
//     if (!window.confirm('Delete this personnel?')) return;
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/personnel/${id}`, { method: 'DELETE' });
//       if (!response.ok) throw new Error('Failed');
//       alert('Deleted successfully!');
//       setShowUpdateForm(false);
//       setEditingPersonnel(null);
//       fetchPersonnel();
//     } catch (err) {
//       alert('Failed to delete.');
//     }
//   };

//   const handleAddDutyHistory = async (e) => {
//     e.preventDefault();
//     try {
//       // Determine final duty assignment
//       let finalDutyAssignment = dutyHistoryForm.duty_assignment;
//       if (dutyHistoryForm.duty_type === "Others" && dutyHistoryForm.custom_duty) {
//         finalDutyAssignment = dutyHistoryForm.custom_duty;
//       }

//       const dataToSend = {
//         personnel_id: dutyHistoryForm.personnel_id,
//         duty_type: dutyHistoryForm.duty_type,
//         duty_assignment: finalDutyAssignment,
//         location: dutyHistoryForm.location,
//         start_date: dutyHistoryForm.start_date,
//         end_date: dutyHistoryForm.end_date,
//         remarks: dutyHistoryForm.remarks
//       };

//       const response = await fetch(`${API_BASE_URL}/api/duty-history`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(dataToSend),
//       });
//       if (!response.ok) {
//         const errorData = await response.json();
//         alert(`Failed: ${errorData.message}`);
//         return;
//       }
//       alert('Duty history added!');
//       setDutyHistoryForm({
//         personnel_id: "", duty_type: "", duty_assignment: "",
//         location: "", start_date: "", end_date: "", remarks: "", custom_duty: ""
//       });
//       setShowDutyHistoryForm(false);
//       fetchDutyHistory();
//     } catch (err) {
//       alert('Failed to add duty history.');
//     }
//   };

//   const handleDeleteDutyHistory = async (id) => {
//     if (!window.confirm('Delete this duty history?')) return;
//     try {
//       await fetch(`${API_BASE_URL}/api/duty-history/${id}`, { method: 'DELETE' });
//       alert('Deleted!');
//       fetchDutyHistory();
//     } catch (err) {
//       alert('Failed to delete.');
//     }
//   };

//   const handleAddLeave = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/leave`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(leaveForm),
//       });
//       if (!response.ok) {
//         const errorData = await response.json();
//         alert(`Failed: ${errorData.message}`);
//         return;
//       }
//       alert('Leave added!');
//       setLeaveForm({
//         personnel_id: "", leave_type: "casual", start_date: "", end_date: "",
//         reason: "", status: "pending", remarks: ""
//       });
//       setShowLeaveForm(false);
//       fetchLeaves();
//     } catch (err) {
//       alert('Failed to add leave.');
//     }
//   };

//   const handleDeleteLeave = async (id) => {
//     if (!window.confirm('Delete this leave?')) return;
//     try {
//       await fetch(`${API_BASE_URL}/api/leave/${id}`, { method: 'DELETE' });
//       alert('Deleted!');
//       fetchLeaves();
//     } catch (err) {
//       alert('Failed to delete.');
//     }
//   };

//   const handleApproveLeave = async (id) => {
//     try {
//       await fetch(`${API_BASE_URL}/api/leave/${id}/status`, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ status: 'approved', approved_by: 1, remarks: 'Approved' }),
//       });
//       alert('Leave approved!');
//       fetchLeaves();
//     } catch (err) {
//       alert('Failed to approve.');
//     }
//   };

//   const handleRejectLeave = async (id) => {
//     const remarks = prompt('Enter rejection reason:');
//     if (!remarks) return;
//     try {
//       await fetch(`${API_BASE_URL}/api/leave/${id}/status`, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ status: 'rejected', approved_by: 1, remarks }),
//       });
//       alert('Leave rejected!');
//       fetchLeaves();
//     } catch (err) {
//       alert('Failed to reject.');
//     }
//   };

//   const ranks = ["SSP", "SP", "Additional SP", 
//     "Deputy SP", "Inspector", "Sub-Inspector", "ASI", "Head Constable", "Constable"];
//   const dutyTypes = ["Fixed Duties", "Dynamic Duties", "Others"];
//   const statuses = ["active", "on-leave", "transferred", "retired"];
//   const leaveTypes = ["casual", "sick", "earned", "special", "maternity", "paternity"];
//   const leaveStatuses = ["pending", "approved", "rejected"];

//   const getDutyAssignments = (dutyType) => {
//     if (dutyType === "Others") {
//       return [];
//     }
//     return dutyCategories[dutyType] || [];
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString('en-IN');
//   };

//   // Data to display based on search state
//   const displayPersonnel = isSearching ? searchResults : personnel;
//   const displayDutyHistory = isSearching 
//     ? dutyHistory.filter(record => 
//         searchResults.some(person => person.id === record.personnel_id))
//     : dutyHistory;
//   const displayLeaves = isSearching
//     ? leaves.filter(leave =>
//         searchResults.some(person => person.id === leave.personnel_id))
//     : leaves;

//   if (loading && personnel.length === 0) {
//     return (
//       <div className="admin-container">
//         <div className="loading-spinner"><p>Loading...</p></div>
//       </div>
//     );
//   }

//   return (
//     <div className="admin-container">
//       <h1 className="admin-header">👮 Admin Panel - Management System</h1>
      
//       {/* Search Section */}
//       <div className="search-section">
//         <div className="search-container">
//           <input 
//             type="text" 
//             placeholder="Search by PNO number, name, rank, or police station..." 
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             onKeyPress={handleSearchKeyPress}
//             className="search-input"
//           />
//           <button 
//             className="btn btn-primary search-btn"
//             onClick={handleSearch}
//             disabled={!searchTerm.trim()}
//           >
//             🔍 Search
//           </button>
//           {isSearching && (
//             <button 
//               className="btn btn-secondary clear-search-btn"
//               onClick={handleClearSearch}
//             >
//               ✖ Clear
//             </button>
//           )}
//         </div>
//         {isSearching && (
//           <div className="search-info">
//             <span className="search-results-count">
//               Found {searchResults.length} result(s) for "{searchTerm}"
//             </span>
//           </div>
//         )}
//       </div>
      
//       <div className="admin-tabs-container">
//         <div className="admin-tabs">
//           <button className={`tab-btn ${activeTab === 'personnel' ? 'active' : ''}`}
//             onClick={() => setActiveTab('personnel')}>👥 Personnel</button>
//           <button className={`tab-btn ${activeTab === 'duty-history' ? 'active' : ''}`}
//             onClick={() => setActiveTab('duty-history')}>📋 Duty History</button>
//           <button className={`tab-btn ${activeTab === 'leaves' ? 'active' : ''}`}
//             onClick={() => setActiveTab('leaves')}>🏖️ Leaves</button>
//         </div>
//         <button 
//           className="btn btn-refresh-top" 
//           onClick={handleRefreshAll}
//           disabled={loading}
//         >
//           {loading ? '⟳ Refreshing...' : '🔄 Refresh All'}
//         </button>
//       </div>

//       <div className="admin-sections">
//         {activeTab === 'personnel' && (
//           <div className="quarter-section">
//             <div className="section-header">
//               <h2>Personnel Management {isSearching && `(Search Results: ${displayPersonnel.length})`}</h2>
//               <div className="header-buttons">
//                 <button className="btn btn-primary"
//                   onClick={() => { setShowPersonnelForm(!showPersonnelForm); setShowUpdateForm(false); }}>
//                   {showPersonnelForm ? '✖ Cancel' : '+ Add Personnel'}
//                 </button>
//                 <button className="btn btn-secondary"
//                   onClick={() => { setShowUpdateForm(!showUpdateForm); setShowPersonnelForm(false); }}>
//                   {showUpdateForm ? '✖ Cancel' : '✏️ Update'}
//                 </button>
//               </div>
//             </div>

//             {showPersonnelForm && (
//               <div className="update-quarter-form">
//                 <h3>➕ Add Personnel</h3>
//                 <form onSubmit={handleAddPersonnel}>
//                   <div className="form-grid">
//                     <div className="form-group">
//                       <label>PNO Number *</label>
//                       <input placeholder="PNO001" value={personnelForm.pno_no}
//                         onChange={(e) => setPersonnelForm({...personnelForm, pno_no: e.target.value})} required />
//                     </div>
//                     <div className="form-group">
//                       <label>Name *</label>
//                       <input placeholder="Full name" value={personnelForm.name}
//                         onChange={(e) => setPersonnelForm({...personnelForm, name: e.target.value})} required />
//                     </div>
//                     <div className="form-group">
//                       <label>Rank *</label>
//                       <select value={personnelForm.rank}
//                         onChange={(e) => setPersonnelForm({...personnelForm, rank: e.target.value})} required>
//                         <option value="">Select</option>
//                         {ranks.map(r => <option key={r} value={r}>{r}</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Police Station</label>
//                       <input placeholder="Hazratganj" value={personnelForm.police_station}
//                         onChange={(e) => setPersonnelForm({...personnelForm, police_station: e.target.value})} />
//                     </div>
//                     <div className="form-group">
//                       <label>Contact</label>
//                       <input placeholder="10-digit" maxLength="10" value={personnelForm.contact_number}
//                         onChange={(e) => setPersonnelForm({...personnelForm, contact_number: e.target.value})} />
//                     </div>
//                     <div className="form-group">
//                       <label>Allotment Date</label>
//                       <input type="date" value={personnelForm.joining_date}
//                         onChange={(e) => setPersonnelForm({...personnelForm, joining_date: e.target.value})} />
//                     </div>
//                     <div className="form-group">
//                       <label>Duty Type</label>
//                       <select value={personnelForm.duty_type}
//                         onChange={(e) => setPersonnelForm({...personnelForm, duty_type: e.target.value, duty_assignment: "", custom_duty: ""})}>
//                         <option value="">Select (Optional)</option>
//                         {dutyTypes.map(t => <option key={t} value={t}>{t}</option>)}
//                       </select>
//                     </div>
//                     {personnelForm.duty_type && personnelForm.duty_type !== "Others" && (
//                       <div className="form-group">
//                         <label>Duty Assignment</label>
//                         <select value={personnelForm.duty_assignment}
//                           onChange={(e) => setPersonnelForm({...personnelForm, duty_assignment: e.target.value})}>
//                           <option value="">Select (Optional - Will be Reserved)</option>
//                           {getDutyAssignments(personnelForm.duty_type).map(d => (
//                             <option key={d} value={d}>{d}</option>
//                           ))}
//                         </select>
//                       </div>
//                     )}
//                     {personnelForm.duty_type === "Others" && (
//                       <div className="form-group">
//                         <label>Custom Duty Type</label>
//                         <input 
//                           placeholder="Enter custom duty type" 
//                           value={personnelForm.custom_duty}
//                           onChange={(e) => setPersonnelForm({...personnelForm, custom_duty: e.target.value})} 
//                         />
//                       </div>
//                     )}
//                     <div className="form-group">
//                       <label>Status *</label>
//                       <select value={personnelForm.status}
//                         onChange={(e) => setPersonnelForm({...personnelForm, status: e.target.value})} required>
//                         {statuses.map(s => <option key={s} value={s}>{s}</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group" style={{gridColumn: '1/-1'}}>
//                       <label>Personnel Photo</label>
//                       <input 
//                         type="file" 
//                         accept="image/*"
//                         onChange={handleImageChange}
//                         className="file-input"
//                       />
//                       {imagePreview && (
//                         <div className="image-preview-container">
//                           <img src={imagePreview} alt="Preview" className="image-preview" />
//                           <button 
//                             type="button" 
//                             className="btn btn-secondary"
//                             onClick={() => {
//                               setSelectedImage(null);
//                               setImagePreview(null);
//                             }}
//                           >
//                             ✖ Remove Image
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="form-actions">
//                     <button type="submit" className="btn btn-primary">✓ Add</button>
//                   </div>
//                 </form>
//               </div>
//             )}

//             {showUpdateForm && (
//               <div className="update-quarter-form">
//                 <h3>✏️ Update Personnel</h3>
//                 <form onSubmit={handleUpdatePersonnel}>
//                   <div className="form-group">
//                     <label>Select Personnel *</label>
//                     <select value={editingPersonnel?.id || ""}
//                       onChange={(e) => {
//                         const p = personnel.find(x => x.id === parseInt(e.target.value));
//                         if (p) {
//                           setEditingPersonnel({...p, joining_date: p.joining_date?.split('T')[0], custom_duty: ""});
//                           setUpdateImagePreview(p.image_url ? `${API_BASE_URL}${p.image_url}` : null);
//                         }
//                       }} required>
//                       <option value="">-- Select --</option>
//                       {personnel.map(p => (
//                         <option key={p.id} value={p.id}>{p.name} ({p.pno_no})</option>
//                       ))}
//                     </select>
//                   </div>
//                   {editingPersonnel && (
//                     <>
//                       <div className="form-grid">
//                         <div className="form-group">
//                           <label>PNO *</label>
//                           <input value={editingPersonnel.pno_no}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, pno_no: e.target.value})} required />
//                         </div>
//                         <div className="form-group">
//                           <label>Name *</label>
//                           <input value={editingPersonnel.name}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, name: e.target.value})} required />
//                         </div>
//                         <div className="form-group">
//                           <label>Rank *</label>
//                           <select value={editingPersonnel.rank}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, rank: e.target.value})} required>
//                             {ranks.map(r => <option key={r} value={r}>{r}</option>)}
//                           </select>
//                         </div>
//                         <div className="form-group">
//                           <label>Police Station</label>
//                           <input value={editingPersonnel.police_station || ""}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, police_station: e.target.value})} />
//                         </div>
//                         <div className="form-group">
//                           <label>Contact</label>
//                           <input value={editingPersonnel.contact_number || ""}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, contact_number: e.target.value})} />
//                         </div>
//                         <div className="form-group">
//                           <label>Duty Type</label>
//                           <select value={editingPersonnel.duty_type || ""}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, duty_type: e.target.value, duty_assignment: "", custom_duty: ""})}>
//                             <option value="">Select (Optional)</option>
//                             {dutyTypes.map(t => <option key={t} value={t}>{t}</option>)}
//                           </select>
//                         </div>
//                         {editingPersonnel.duty_type && editingPersonnel.duty_type !== "Others" && (
//                           <div className="form-group">
//                             <label>Duty Assignment</label>
//                             <select value={editingPersonnel.duty_assignment || ""}
//                               onChange={(e) => setEditingPersonnel({...editingPersonnel, duty_assignment: e.target.value})}>
//                               <option value="">Select (Optional - Will be Reserved)</option>
//                               {getDutyAssignments(editingPersonnel.duty_type).map(d => (
//                                 <option key={d} value={d}>{d}</option>
//                               ))}
//                             </select>
//                           </div>
//                         )}
//                         {editingPersonnel.duty_type === "Others" && (
//                           <div className="form-group">
//                             <label>Custom Duty Type</label>
//                             <input 
//                               placeholder="Enter custom duty type" 
//                               value={editingPersonnel.custom_duty || editingPersonnel.duty_assignment || ""}
//                               onChange={(e) => setEditingPersonnel({...editingPersonnel, custom_duty: e.target.value})} 
//                             />
//                           </div>
//                         )}
//                         <div className="form-group">
//                           <label>Status *</label>
//                           <select value={editingPersonnel.status}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, status: e.target.value})} required>
//                             {statuses.map(s => <option key={s} value={s}>{s}</option>)}
//                           </select>
//                         </div>
//                         <div className="form-group" style={{gridColumn: '1/-1'}}>
//                           <label>Update Photo</label>
//                           <input 
//                             type="file" 
//                             accept="image/*"
//                             onChange={handleUpdateImageChange}
//                             className="file-input"
//                           />
//                           {updateImagePreview && (
//                             <div className="image-preview-container">
//                               <img src={updateImagePreview} alt="Preview" className="image-preview" />
//                               <button 
//                                 type="button" 
//                                 className="btn btn-secondary"
//                                 onClick={() => {
//                                   setUpdateImage(null);
//                                   setUpdateImagePreview(null);
//                                 }}
//                               >
//                                 ✖ Remove Image
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                       <div className="form-actions">
//                         <button type="submit" className="btn btn-primary">✓ Update</button>
//                         <button type="button" className="btn btn-danger"
//                           onClick={() => handleDeletePersonnel(editingPersonnel.id)}>🗑️ Delete</button>
//                       </div>
//                     </>
//                   )}
//                 </form>
//               </div>
//             )}

//             <div className="repair-section">
//               <h3>Personnel Directory ({displayPersonnel.length})</h3>
//               {displayPersonnel.length === 0 ? (
//                 <div className="no-results">
//                   <p>No personnel found {isSearching ? 'matching your search criteria' : ''}</p>
//                 </div>
//               ) : (
//                 <div className="repair-list">
//                   {displayPersonnel.map(p => (
//                     <div key={p.id} className="repair-item">
//                       {p.image_url && (
//                         <div className="personnel-list-image">
//                           <img 
//                             src={`${API_BASE_URL}${p.image_url}`} 
//                             alt={p.name}
//                             onError={(e) => e.target.style.display = 'none'}
//                           />
//                         </div>
//                       )}
//                       <div className="repair-info">
//                         <h4>👤 {p.name} <span className={`status-badge ${p.status}`}>{p.status}</span></h4>
//                         <p><strong>PNO:</strong> {p.pno_no} | <strong>Rank:</strong> {p.rank}</p>
//                         <p><strong>Duty:</strong> {p.duty_type || "N/A"} - {p.duty_assignment || "Reserved"}</p>
//                       </div>
//                       <button className="btn btn-secondary" onClick={() => {
//                         setEditingPersonnel({...p, joining_date: p.joining_date?.split('T')[0], custom_duty: ""});
//                         setUpdateImagePreview(p.image_url ? `${API_BASE_URL}${p.image_url}` : null);
//                         setShowUpdateForm(true);
//                         setShowPersonnelForm(false);
//                       }}>✏️ Edit</button>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         )}
//         {/* Duty History Tab */}
//         {activeTab === 'duty-history' && (
//           <div className="quarter-section">
//             <div className="section-header">
//               <h2>Duty History {isSearching && `(Filtered: ${displayDutyHistory.length})`}</h2>
//               <button className="btn btn-primary"
//                 onClick={() => setShowDutyHistoryForm(!showDutyHistoryForm)}>
//                 {showDutyHistoryForm ? '✖ Cancel' : '+ Add'}
//               </button>
//             </div>

//             {showDutyHistoryForm && (
//               <div className="update-quarter-form">
//                 <h3>➕ Add Duty History</h3>
//                 <form onSubmit={handleAddDutyHistory}>
//                   <div className="form-grid">
//                     <div className="form-group">
//                       <label>Personnel *</label>
//                       <select value={dutyHistoryForm.personnel_id}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, personnel_id: e.target.value})} required>
//                         <option value="">-- Select --</option>
//                         {personnel.map(p => <option key={p.id} value={p.id}>{p.name} ({p.pno_no})</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Duty Type *</label>
//                       <select value={dutyHistoryForm.duty_type}
//                         onChange={(e) => {
//                           setDutyHistoryForm({
//                             ...dutyHistoryForm, 
//                             duty_type: e.target.value,
//                             duty_assignment: getDutyAssignments(e.target.value)[0] // Reset to first duty of selected type
//                           });
//                         }} required>
//                         {dutyTypes.map(t => <option key={t} value={t}>{t}</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Duty Assignment *</label>
//                       <select value={dutyHistoryForm.duty_assignment}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, duty_assignment: e.target.value})} required>
//                         {getDutyAssignments(dutyHistoryForm.duty_type).map(d => (
//                           <option key={d} value={d}>{d}</option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Location</label>
//                       <input placeholder="Police Station" value={dutyHistoryForm.location}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, location: e.target.value})} />
//                     </div>
//                     <div className="form-group">
//                       <label>Start Date *</label>
//                       <input type="date" value={dutyHistoryForm.start_date}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, start_date: e.target.value})} required />
//                     </div>
//                     <div className="form-group">
//                       <label>End Date *</label>
//                       <input type="date" value={dutyHistoryForm.end_date}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, end_date: e.target.value})} required />
//                     </div>
//                     <div className="form-group" style={{gridColumn: '1/-1'}}>
//                       <label>Remarks</label>
//                       <textarea placeholder="Notes..." value={dutyHistoryForm.remarks}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, remarks: e.target.value})} rows={3} />
//                     </div>
//                   </div>
//                   <button type="submit" className="btn btn-primary">✓ Add</button>
//                 </form>
//               </div>
//             )}

//             <div className="repair-section">
//               <h3>Records ({displayDutyHistory.length})</h3>
//               {displayDutyHistory.length === 0 ? (
//                 <div className="no-results">
//                   <p>No duty history records found {isSearching ? 'matching your search criteria' : ''}</p>
//                 </div>
//               ) : (
//                 <div className="repair-list">
//                   {displayDutyHistory.map(r => (
//                     <div key={r.id} className="repair-item">
//                       <div className="repair-info">
//                         <h4>📋 {r.name} ({r.pno_no})</h4>
//                         <p><strong>Duty:</strong> {r.duty_type} - {r.duty_assignment}</p>
//                         <p><strong>Period:</strong> {formatDate(r.start_date)} to {formatDate(r.end_date)}</p>
//                         {r.location && <p><strong>Location:</strong> {r.location}</p>}
//                         {r.remarks && <p><em>{r.remarks}</em></p>}
//                       </div>
//                       <button className="btn btn-danger" onClick={() => handleDeleteDutyHistory(r.id)}>🗑️</button>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {/* Leaves Tab */}
//         {activeTab === 'leaves' && (
//           <div className="quarter-section">
//             <div className="section-header">
//               <h2>Leave Management {isSearching && `(Filtered: ${displayLeaves.length})`}</h2>
//               <button className="btn btn-primary"
//                 onClick={() => setShowLeaveForm(!showLeaveForm)}>
//                 {showLeaveForm ? '✖ Cancel' : '+ Add'}
//               </button>
//             </div>

//             {showLeaveForm && (
//               <div className="update-quarter-form">
//                 <h3>➕ Add Leave</h3>
//                 <form onSubmit={handleAddLeave}>
//                   <div className="form-grid">
//                     <div className="form-group">
//                       <label>Personnel *</label>
//                       <select value={leaveForm.personnel_id}
//                         onChange={(e) => setLeaveForm({...leaveForm, personnel_id: e.target.value})} required>
//                         <option value="">-- Select --</option>
//                         {personnel.map(p => <option key={p.id} value={p.id}>{p.name} ({p.pno_no})</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Leave Type *</label>
//                       <select value={leaveForm.leave_type}
//                         onChange={(e) => setLeaveForm({...leaveForm, leave_type: e.target.value})} required>
//                         {leaveTypes.map(t => <option key={t} value={t}>{t}</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Start *</label>
//                       <input type="date" value={leaveForm.start_date}
//                         onChange={(e) => setLeaveForm({...leaveForm, start_date: e.target.value})} required />
//                     </div>
//                     <div className="form-group">
//                       <label>End *</label>
//                       <input type="date" value={leaveForm.end_date}
//                         onChange={(e) => setLeaveForm({...leaveForm, end_date: e.target.value})} required />
//                     </div>
//                     <div className="form-group">
//                       <label>Status *</label>
//                       <select value={leaveForm.status}
//                         onChange={(e) => setLeaveForm({...leaveForm, status: e.target.value})} required>
//                         {leaveStatuses.map(s => <option key={s} value={s}>{s}</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group" style={{gridColumn: '1/-1'}}>
//                       <label>Reason *</label>
//                       <textarea placeholder="Reason..." value={leaveForm.reason}
//                         onChange={(e) => setLeaveForm({...leaveForm, reason: e.target.value})} required rows={3} />
//                     </div>
//                     <div className="form-group" style={{gridColumn: '1/-1'}}>
//                       <label>Remarks</label>
//                       <textarea placeholder="Admin remarks..." value={leaveForm.remarks}
//                         onChange={(e) => setLeaveForm({...leaveForm, remarks: e.target.value})} rows={2} />
//                     </div>
//                   </div>
//                   <button type="submit" className="btn btn-primary">✓ Add</button>
//                 </form>
//               </div>
//             )}

//             <div className="repair-section">
//               <h3>Leave Records ({displayLeaves.length})</h3>
//               {displayLeaves.length === 0 ? (
//                 <div className="no-results">
//                   <p>No leave records found {isSearching ? 'matching your search criteria' : ''}</p>
//                 </div>
//               ) : (
//                 <div className="repair-list">
//                   {displayLeaves.map(l => (
//                     <div key={l.id} className="repair-item">
//                       <div className="repair-info">
//                         <h4>🏖️ {l.name} ({l.pno_no})</h4>
//                         <p><strong>Type:</strong> {l.leave_type} | <span className={`status-badge ${l.status}`}>{l.status}</span></p>
//                         <p><strong>Period:</strong> {formatDate(l.start_date)} to {formatDate(l.end_date)}</p>
//                         <p><strong>Reason:</strong> {l.reason}</p>
//                         {l.remarks && <p><em>Remarks: {l.remarks}</em></p>}
//                       </div>
//                       <div className="repair-actions">
//                         {l.status === 'pending' && (
//                           <>
//                             <button className="btn btn-primary" onClick={() => handleApproveLeave(l.id)}>✓</button>
//                             <button className="btn btn-secondary" onClick={() => handleRejectLeave(l.id)}>✖</button>
//                           </>
//                         )}
//                         <button className="btn btn-danger" onClick={() => handleDeleteLeave(l.id)}>🗑️</button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default AdminPanel;

// import React, { useState, useEffect } from "react";
// import "./AdminPanel.css";

// function AdminPanel() {
//   const [personnel, setPersonnel] = useState([]);
//   const [dutyHistory, setDutyHistory] = useState([]);
//   const [leaves, setLeaves] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  
//   const [showPersonnelForm, setShowPersonnelForm] = useState(false);
//   const [showUpdateForm, setShowUpdateForm] = useState(false);
//   const [showDutyHistoryForm, setShowDutyHistoryForm] = useState(false);
//   const [showLeaveForm, setShowLeaveForm] = useState(false);
  
//   const [editingPersonnel, setEditingPersonnel] = useState(null);
//   const [activeTab, setActiveTab] = useState('personnel');
  
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [updateImage, setUpdateImage] = useState(null);
//   const [updateImagePreview, setUpdateImagePreview] = useState(null);
  
//   const API_BASE_URL = process.env.REACT_APP_API_URL;
  
//   const dutyCategories = {
//     "Fixed Duties": [
//       "General Duty",
//       "General Duty plus Art D",
//       "Field Duty",
//       "Field Medical",
//       "City Medical Patrol",
//       "City Establishment",
//       "Guard Janpad / State Post",
//       "Patrol Mobile DSP Wise",
//       "Mahanagar / City District Wise",
//       "Court Duty",
//       "Court Security Reserve Duty",
//       "VIP Duty / Rank Security Guard",
//       "VIP Duty / VIP Security Reserve Duty",
//       "City Line Position Duty",
//       "Financial Institution Duty",
//       "Different Flag Parade Duty",
//       "Criminality Affected Special Duty",
//       "Night Patrol Duty",
//       "Paper / Other Important Security Duty",
//       "Sampark Suraksha Duty",
//       "Different Flag Parade Duty (2)"
//     ],
//     "Dynamic Duties": [
//       "Law and Order Parade Duty",
//       "Law and Order Janpad / Guard Janpad / State Establishment",
//       "Court Security Duty",
//       "VIP Duty / VIP Accompanying Security Duty",
//       "Audit Janpad / State Janpad / Other State Visit Security Duty",
//       "Audit Janpad / State Janpad / State Special Escort Duty",
//       "Different Flag Election Duty",
//       "Svayam Gir Security Duty",
//       "Eidgah Security Duty"
//     ],
//     "Others": []
//   };

//   const [personnelForm, setPersonnelForm] = useState({
//     pno_no: "", name: "", rank: "", police_station: "",
//     contact_number: "", joining_date: "", duty_type: "",
//     duty_assignment: "", status: "active", custom_duty: ""
//   });

//   const [dutyHistoryForm, setDutyHistoryForm] = useState({
//     personnel_id: "", duty_type: "", duty_assignment: "",
//     location: "", start_date: "", end_date: "", remarks: "", custom_duty: ""
//   });

//   const [leaveForm, setLeaveForm] = useState({
//     personnel_id: "", leave_type: "casual", start_date: "", end_date: "",
//     reason: "", status: "pending", remarks: ""
//   });

//   useEffect(() => {
//     fetchPersonnel();
//     fetchDutyHistory();
//     fetchLeaves();
//   }, []);

//   const fetchPersonnel = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${API_BASE_URL}/api/personnel`);
//       if (!response.ok) throw new Error('Failed to fetch personnel');
//       const data = await response.json();
//       setPersonnel(data);
//       setError(null);
//     } catch (err) {
//       console.error('Error fetching personnel:', err);
//       setError('Failed to load personnel');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchDutyHistory = async () => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/duty-history`);
//       if (!response.ok) throw new Error('Failed to fetch duty history');
//       const data = await response.json();
//       setDutyHistory(data);
//     } catch (err) {
//       console.error('Error fetching duty history:', err);
//     }
//   };

//   const fetchLeaves = async () => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/leave`);
//       if (!response.ok) throw new Error('Failed to fetch leaves');
//       const data = await response.json();
//       setLeaves(data);
//     } catch (err) {
//       console.error('Error fetching leaves:', err);
//     }
//   };

//   const handleRefreshAll = async () => {
//     try {
//       setLoading(true);
//       await Promise.all([
//         fetchPersonnel(),
//         fetchDutyHistory(),
//         fetchLeaves()
//       ]);
//       alert('All data refreshed successfully!');
//     } catch (err) {
//       alert('Failed to refresh data. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setSelectedImage(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleUpdateImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setUpdateImage(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setUpdateImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleAddPersonnel = async (e) => {
//     e.preventDefault();
//     try {
//       const formData = new FormData();
      
//       // Determine final duty assignment
//       let finalDutyAssignment = personnelForm.duty_assignment;
//       if (personnelForm.duty_type === "Others" && personnelForm.custom_duty) {
//         finalDutyAssignment = personnelForm.custom_duty;
//       } else if (!finalDutyAssignment || finalDutyAssignment === "") {
//         finalDutyAssignment = "Reserved";
//       }
      
//       Object.keys(personnelForm).forEach(key => {
//         if (key !== 'custom_duty') {
//           if (key === 'duty_assignment') {
//             formData.append(key, finalDutyAssignment);
//           } else {
//             formData.append(key, personnelForm[key]);
//           }
//         }
//       });
      
//       if (selectedImage) {
//         formData.append('image', selectedImage);
//       }
      
//       const response = await fetch(`${API_BASE_URL}/api/personnel`, {
//         method: 'POST',
//         body: formData,
//       });
      
//       if (!response.ok) {
//         const errorData = await response.json();
//         alert(`Failed: ${errorData.message || 'Unknown error'}`);
//         return;
//       }
      
//       alert('Personnel added successfully!');
//       setPersonnelForm({
//         pno_no: "", name: "", rank: "", police_station: "",
//         contact_number: "", joining_date: "", duty_type: "",
//         duty_assignment: "", status: "active", custom_duty: ""
//       });
//       setSelectedImage(null);
//       setImagePreview(null);
//       setShowPersonnelForm(false);
//       fetchPersonnel();
//     } catch (err) {
//       console.error('Error:', err);
//       alert('Failed to add personnel.');
//     }
//   };

// const handleUpdatePersonnel = async (e) => {
//   e.preventDefault();
//   try {
//     const formData = new FormData();
    
//     // Determine final duty assignment
//     let finalDutyAssignment = editingPersonnel.duty_assignment;
//     if (editingPersonnel.duty_type === "Others" && editingPersonnel.custom_duty) {
//       finalDutyAssignment = editingPersonnel.custom_duty;
//     } else if (!finalDutyAssignment || finalDutyAssignment === "") {
//       finalDutyAssignment = "Reserved";
//     }

//     // Get current personnel data to compare
//     const currentPersonnel = personnel.find(p => p.id === editingPersonnel.id);
//     const oldDutyAssignment = currentPersonnel?.duty_assignment;
//     const oldDutyType = currentPersonnel?.duty_type;
    
//     Object.keys(editingPersonnel).forEach(key => {
//       if (key !== 'image_url' && key !== 'custom_duty') {
//         if (key === 'duty_assignment') {
//           formData.append(key, finalDutyAssignment);
//         } else {
//           formData.append(key, editingPersonnel[key]);
//         }
//       }
//     });
    
//     if (updateImage) {
//       formData.append('image', updateImage);
//     }
    
//     const response = await fetch(`${API_BASE_URL}/api/personnel/${editingPersonnel.id}`, {
//       method: 'PUT',
//       body: formData,
//     });
    
//     if (!response.ok) throw new Error('Failed to update');
    
//     // **ENHANCED DUTY HISTORY MANAGEMENT**
//     if (oldDutyAssignment !== finalDutyAssignment) {
//       try {
//         const today = new Date().toISOString().split('T')[0];
//         const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
        
//         // 1. CLOSE THE PREVIOUS DUTY RECORD (if existed and wasn't Reserved)
//         if (oldDutyAssignment && oldDutyAssignment !== "Reserved") {
//           // Find active duty history records for this personnel
//           const dutyHistoryResponse = await fetch(
//             `${API_BASE_URL}/api/duty-history/personnel/${editingPersonnel.id}`
//           );
//           if (dutyHistoryResponse.ok) {
//             const dutyHistory = await dutyHistoryResponse.json();
            
//             // Find active records (without end date or future end date)
//             const activeRecords = dutyHistory.filter(record => 
//               !record.end_date || new Date(record.end_date) >= new Date()
//             );
            
//             // Close previous active records
//             for (const record of activeRecords) {
//               await fetch(`${API_BASE_URL}/api/duty-history/${record.id}`, {
//                 method: 'PUT',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                   ...record,
//                   end_date: yesterday, // End yesterday
//                   remarks: record.remarks ? 
//                     `${record.remarks} | Duty changed on ${today}` : 
//                     `Duty changed on ${today}`
//                 })
//               });
//             }
//           }
//         }
        
//         // 2. CREATE NEW DUTY HISTORY RECORD FOR CURRENT DUTY (if not Reserved)
//         if (finalDutyAssignment && finalDutyAssignment !== "Reserved") {
//           const dutyHistoryData = {
//             personnel_id: editingPersonnel.id,
//             duty_type: editingPersonnel.duty_type || "Fixed Duties",
//             duty_assignment: finalDutyAssignment,
//             start_date: today,
//             end_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
//             location: editingPersonnel.police_station || "",
//             remarks: `Duty assignment: ${oldDutyAssignment || "Reserved"} → ${finalDutyAssignment}`
//           };

//           await fetch(`${API_BASE_URL}/api/duty-history`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(dutyHistoryData),
//           });
//         }
        
//       } catch (historyErr) {
//         console.error('Failed to update duty history records:', historyErr);
//         // Don't fail the main update if history update fails
//       }
//     }
    
//     alert('Updated successfully with duty history maintained!');
//     setShowUpdateForm(false);
//     setEditingPersonnel(null);
//     setUpdateImage(null);
//     setUpdateImagePreview(null);
//     fetchPersonnel();
//     fetchDutyHistory(); // Refresh duty history
//   } catch (err) {
//     alert('Failed to update personnel.');
//   }
// };

//   const handleDeletePersonnel = async (id) => {
//     if (!window.confirm('Delete this personnel?')) return;
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/personnel/${id}`, { method: 'DELETE' });
//       if (!response.ok) throw new Error('Failed');
//       alert('Deleted successfully!');
//       setShowUpdateForm(false);
//       setEditingPersonnel(null);
//       fetchPersonnel();
//     } catch (err) {
//       alert('Failed to delete.');
//     }
//   };

//   const handleAddDutyHistory = async (e) => {
//     e.preventDefault();
//     try {
//       // Determine final duty assignment
//       let finalDutyAssignment = dutyHistoryForm.duty_assignment;
//       if (dutyHistoryForm.duty_type === "Others" && dutyHistoryForm.custom_duty) {
//         finalDutyAssignment = dutyHistoryForm.custom_duty;
//       }

//       const dataToSend = {
//         personnel_id: dutyHistoryForm.personnel_id,
//         duty_type: dutyHistoryForm.duty_type,
//         duty_assignment: finalDutyAssignment,
//         location: dutyHistoryForm.location,
//         start_date: dutyHistoryForm.start_date,
//         end_date: dutyHistoryForm.end_date,
//         remarks: dutyHistoryForm.remarks
//       };

//       const response = await fetch(`${API_BASE_URL}/api/duty-history`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(dataToSend),
//       });
//       if (!response.ok) {
//         const errorData = await response.json();
//         alert(`Failed: ${errorData.message}`);
//         return;
//       }
//       alert('Duty history added!');
//       setDutyHistoryForm({
//         personnel_id: "", duty_type: "", duty_assignment: "",
//         location: "", start_date: "", end_date: "", remarks: "", custom_duty: ""
//       });
//       setShowDutyHistoryForm(false);
//       fetchDutyHistory();
//     } catch (err) {
//       alert('Failed to add duty history.');
//     }
//   };

//   const handleDeleteDutyHistory = async (id) => {
//     if (!window.confirm('Delete this duty history?')) return;
//     try {
//       await fetch(`${API_BASE_URL}/api/duty-history/${id}`, { method: 'DELETE' });
//       alert('Deleted!');
//       fetchDutyHistory();
//     } catch (err) {
//       alert('Failed to delete.');
//     }
//   };

//   const handleAddLeave = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/leave`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(leaveForm),
//       });
//       if (!response.ok) {
//         const errorData = await response.json();
//         alert(`Failed: ${errorData.message}`);
//         return;
//       }
//       alert('Leave added!');
//       setLeaveForm({
//         personnel_id: "", leave_type: "casual", start_date: "", end_date: "",
//         reason: "", status: "pending", remarks: ""
//       });
//       setShowLeaveForm(false);
//       fetchLeaves();
//     } catch (err) {
//       alert('Failed to add leave.');
//     }
//   };

//   const handleDeleteLeave = async (id) => {
//     if (!window.confirm('Delete this leave?')) return;
//     try {
//       await fetch(`${API_BASE_URL}/api/leave/${id}`, { method: 'DELETE' });
//       alert('Deleted!');
//       fetchLeaves();
//     } catch (err) {
//       alert('Failed to delete.');
//     }
//   };

//   const handleApproveLeave = async (id) => {
//     try {
//       await fetch(`${API_BASE_URL}/api/leave/${id}/status`, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ status: 'approved', approved_by: 1, remarks: 'Approved' }),
//       });
//       alert('Leave approved!');
//       fetchLeaves();
//     } catch (err) {
//       alert('Failed to approve.');
//     }
//   };

//   const handleRejectLeave = async (id) => {
//     const remarks = prompt('Enter rejection reason:');
//     if (!remarks) return;
//     try {
//       await fetch(`${API_BASE_URL}/api/leave/${id}/status`, {
//         method: 'PATCH',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ status: 'rejected', approved_by: 1, remarks }),
//       });
//       alert('Leave rejected!');
//       fetchLeaves();
//     } catch (err) {
//       alert('Failed to reject.');
//     }
//   };

//   const ranks = ["SSP", "SP", "Additional SP", 
//     "Deputy SP", "Inspector", "Sub-Inspector", "ASI", "Head Constable", "Constable"];
//   const dutyTypes = ["Fixed Duties", "Dynamic Duties", "Others"];
//   const statuses = ["active", "on-leave", "transferred", "retired"];
//   const leaveTypes = ["casual", "sick", "earned", "special", "maternity", "paternity"];
//   const leaveStatuses = ["pending", "approved", "rejected"];

//   const getDutyAssignments = (dutyType) => {
//     if (dutyType === "Others") {
//       return [];
//     }
//     return dutyCategories[dutyType] || [];
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString('en-IN');
//   };

//   if (loading && personnel.length === 0) {
//     return (
//       <div className="admin-container">
//         <div className="loading-spinner"><p>Loading...</p></div>
//       </div>
//     );
//   }

//   return (
//     <div className="admin-container">
//       <h1 className="admin-header">👮 Admin Panel - Management System</h1>
      
//       <div className="admin-tabs-container">
//         <div className="admin-tabs">
//           <button className={`tab-btn ${activeTab === 'personnel' ? 'active' : ''}`}
//             onClick={() => setActiveTab('personnel')}>👥 Personnel</button>
//           <button className={`tab-btn ${activeTab === 'duty-history' ? 'active' : ''}`}
//             onClick={() => setActiveTab('duty-history')}>📋 Duty History</button>
//           <button className={`tab-btn ${activeTab === 'leaves' ? 'active' : ''}`}
//             onClick={() => setActiveTab('leaves')}>🏖️ Leaves</button>
//         </div>
//         <button 
//           className="btn btn-refresh-top" 
//           onClick={handleRefreshAll}
//           disabled={loading}
//         >
//           {loading ? '⟳ Refreshing...' : '🔄 Refresh All'}
//         </button>
//       </div>

//       <div className="admin-sections">
//         {activeTab === 'personnel' && (
//           <div className="quarter-section">
//             <div className="section-header">
//               <h2>Personnel Management</h2>
//               <div className="header-buttons">
//                 <button className="btn btn-primary"
//                   onClick={() => { setShowPersonnelForm(!showPersonnelForm); setShowUpdateForm(false); }}>
//                   {showPersonnelForm ? '✖ Cancel' : '+ Add Personnel'}
//                 </button>
//                 <button className="btn btn-secondary"
//                   onClick={() => { setShowUpdateForm(!showUpdateForm); setShowPersonnelForm(false); }}>
//                   {showUpdateForm ? '✖ Cancel' : '✏️ Update'}
//                 </button>
//               </div>
//             </div>

//             {showPersonnelForm && (
//               <div className="update-quarter-form">
//                 <h3>➕ Add Personnel</h3>
//                 <form onSubmit={handleAddPersonnel}>
//                   <div className="form-grid">
//                     <div className="form-group">
//                       <label>PNO Number *</label>
//                       <input placeholder="PNO001" value={personnelForm.pno_no}
//                         onChange={(e) => setPersonnelForm({...personnelForm, pno_no: e.target.value})} required />
//                     </div>
//                     <div className="form-group">
//                       <label>Name *</label>
//                       <input placeholder="Full name" value={personnelForm.name}
//                         onChange={(e) => setPersonnelForm({...personnelForm, name: e.target.value})} required />
//                     </div>
//                     <div className="form-group">
//                       <label>Rank *</label>
//                       <select value={personnelForm.rank}
//                         onChange={(e) => setPersonnelForm({...personnelForm, rank: e.target.value})} required>
//                         <option value="">Select</option>
//                         {ranks.map(r => <option key={r} value={r}>{r}</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Police Station</label>
//                       <input placeholder="Hazratganj" value={personnelForm.police_station}
//                         onChange={(e) => setPersonnelForm({...personnelForm, police_station: e.target.value})} />
//                     </div>
//                     <div className="form-group">
//                       <label>Contact</label>
//                       <input placeholder="10-digit" maxLength="10" value={personnelForm.contact_number}
//                         onChange={(e) => setPersonnelForm({...personnelForm, contact_number: e.target.value})} />
//                     </div>
//                     <div className="form-group">
//                       <label>Allotment Date</label>
//                       <input type="date" value={personnelForm.joining_date}
//                         onChange={(e) => setPersonnelForm({...personnelForm, joining_date: e.target.value})} />
//                     </div>
//                     <div className="form-group">
//                       <label>Duty Type</label>
//                       <select value={personnelForm.duty_type}
//                         onChange={(e) => setPersonnelForm({...personnelForm, duty_type: e.target.value, duty_assignment: "", custom_duty: ""})}>
//                         <option value="">Select (Optional)</option>
//                         {dutyTypes.map(t => <option key={t} value={t}>{t}</option>)}
//                       </select>
//                     </div>
//                     {personnelForm.duty_type && personnelForm.duty_type !== "Others" && (
//                       <div className="form-group">
//                         <label>Duty Assignment</label>
//                         <select value={personnelForm.duty_assignment}
//                           onChange={(e) => setPersonnelForm({...personnelForm, duty_assignment: e.target.value})}>
//                           <option value="">Select (Optional - Will be Reserved)</option>
//                           {getDutyAssignments(personnelForm.duty_type).map(d => (
//                             <option key={d} value={d}>{d}</option>
//                           ))}
//                         </select>
//                       </div>
//                     )}
//                     {personnelForm.duty_type === "Others" && (
//                       <div className="form-group">
//                         <label>Custom Duty Type</label>
//                         <input 
//                           placeholder="Enter custom duty type" 
//                           value={personnelForm.custom_duty}
//                           onChange={(e) => setPersonnelForm({...personnelForm, custom_duty: e.target.value})} 
//                         />
//                       </div>
//                     )}
//                     <div className="form-group">
//                       <label>Status *</label>
//                       <select value={personnelForm.status}
//                         onChange={(e) => setPersonnelForm({...personnelForm, status: e.target.value})} required>
//                         {statuses.map(s => <option key={s} value={s}>{s}</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group" style={{gridColumn: '1/-1'}}>
//                       <label>Personnel Photo</label>
//                       <input 
//                         type="file" 
//                         accept="image/*"
//                         onChange={handleImageChange}
//                         className="file-input"
//                       />
//                       {imagePreview && (
//                         <div className="image-preview-container">
//                           <img src={imagePreview} alt="Preview" className="image-preview" />
//                           <button 
//                             type="button" 
//                             className="btn btn-secondary"
//                             onClick={() => {
//                               setSelectedImage(null);
//                               setImagePreview(null);
//                             }}
//                           >
//                             ✖ Remove Image
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="form-actions">
//                     <button type="submit" className="btn btn-primary">✓ Add</button>
//                   </div>
//                 </form>
//               </div>
//             )}

//             {showUpdateForm && (
//               <div className="update-quarter-form">
//                 <h3>✏️ Update Personnel</h3>
//                 <form onSubmit={handleUpdatePersonnel}>
//                   <div className="form-group">
//                     <label>Select Personnel *</label>
//                     <select value={editingPersonnel?.id || ""}
//                       onChange={(e) => {
//                         const p = personnel.find(x => x.id === parseInt(e.target.value));
//                         if (p) {
//                           setEditingPersonnel({...p, joining_date: p.joining_date?.split('T')[0], custom_duty: ""});
//                           setUpdateImagePreview(p.image_url ? `${API_BASE_URL}${p.image_url}` : null);
//                         }
//                       }} required>
//                       <option value="">-- Select --</option>
//                       {personnel.map(p => (
//                         <option key={p.id} value={p.id}>{p.name} ({p.pno_no})</option>
//                       ))}
//                     </select>
//                   </div>
//                   {editingPersonnel && (
//                     <>
//                       <div className="form-grid">
//                         <div className="form-group">
//                           <label>PNO *</label>
//                           <input value={editingPersonnel.pno_no}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, pno_no: e.target.value})} required />
//                         </div>
//                         <div className="form-group">
//                           <label>Name *</label>
//                           <input value={editingPersonnel.name}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, name: e.target.value})} required />
//                         </div>
//                         <div className="form-group">
//                           <label>Rank *</label>
//                           <select value={editingPersonnel.rank}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, rank: e.target.value})} required>
//                             {ranks.map(r => <option key={r} value={r}>{r}</option>)}
//                           </select>
//                         </div>
//                         <div className="form-group">
//                           <label>Police Station</label>
//                           <input value={editingPersonnel.police_station || ""}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, police_station: e.target.value})} />
//                         </div>
//                         <div className="form-group">
//                           <label>Contact</label>
//                           <input value={editingPersonnel.contact_number || ""}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, contact_number: e.target.value})} />
//                         </div>
//                         <div className="form-group">
//                           <label>Duty Type</label>
//                           <select value={editingPersonnel.duty_type || ""}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, duty_type: e.target.value, duty_assignment: "", custom_duty: ""})}>
//                             <option value="">Select (Optional)</option>
//                             {dutyTypes.map(t => <option key={t} value={t}>{t}</option>)}
//                           </select>
//                         </div>
//                         {editingPersonnel.duty_type && editingPersonnel.duty_type !== "Others" && (
//                           <div className="form-group">
//                             <label>Duty Assignment</label>
//                             <select value={editingPersonnel.duty_assignment || ""}
//                               onChange={(e) => setEditingPersonnel({...editingPersonnel, duty_assignment: e.target.value})}>
//                               <option value="">Select (Optional - Will be Reserved)</option>
//                               {getDutyAssignments(editingPersonnel.duty_type).map(d => (
//                                 <option key={d} value={d}>{d}</option>
//                               ))}
//                             </select>
//                           </div>
//                         )}
//                         {editingPersonnel.duty_type === "Others" && (
//                           <div className="form-group">
//                             <label>Custom Duty Type</label>
//                             <input 
//                               placeholder="Enter custom duty type" 
//                               value={editingPersonnel.custom_duty || editingPersonnel.duty_assignment || ""}
//                               onChange={(e) => setEditingPersonnel({...editingPersonnel, custom_duty: e.target.value})} 
//                             />
//                           </div>
//                         )}
//                         <div className="form-group">
//                           <label>Status *</label>
//                           <select value={editingPersonnel.status}
//                             onChange={(e) => setEditingPersonnel({...editingPersonnel, status: e.target.value})} required>
//                             {statuses.map(s => <option key={s} value={s}>{s}</option>)}
//                           </select>
//                         </div>
//                         <div className="form-group" style={{gridColumn: '1/-1'}}>
//                           <label>Update Photo</label>
//                           <input 
//                             type="file" 
//                             accept="image/*"
//                             onChange={handleUpdateImageChange}
//                             className="file-input"
//                           />
//                           {updateImagePreview && (
//                             <div className="image-preview-container">
//                               <img src={updateImagePreview} alt="Preview" className="image-preview" />
//                               <button 
//                                 type="button" 
//                                 className="btn btn-secondary"
//                                 onClick={() => {
//                                   setUpdateImage(null);
//                                   setUpdateImagePreview(null);
//                                 }}
//                               >
//                                 ✖ Remove Image
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                       <div className="form-actions">
//                         <button type="submit" className="btn btn-primary">✓ Update</button>
//                         <button type="button" className="btn btn-danger"
//                           onClick={() => handleDeletePersonnel(editingPersonnel.id)}>🗑️ Delete</button>
//                       </div>
//                     </>
//                   )}
//                 </form>
//               </div>
//             )}

//             <div className="repair-section">
//               <h3>Personnel Directory ({personnel.length})</h3>
//               <div className="repair-list">
//                 {personnel.map(p => (
//                   <div key={p.id} className="repair-item">
//                     {p.image_url && (
//                       <div className="personnel-list-image">
//                         <img 
//                           src={`${API_BASE_URL}${p.image_url}`} 
//                           alt={p.name}
//                           onError={(e) => e.target.style.display = 'none'}
//                         />
//                       </div>
//                     )}
//                     <div className="repair-info">
//                       <h4>👤 {p.name} <span className={`status-badge ${p.status}`}>{p.status}</span></h4>
//                       <p><strong>PNO:</strong> {p.pno_no} | <strong>Rank:</strong> {p.rank}</p>
//                       <p><strong>Duty:</strong> {p.duty_type || "N/A"} - {p.duty_assignment || "Reserved"}</p>
//                     </div>
//                     <button className="btn btn-secondary" onClick={() => {
//                       setEditingPersonnel({...p, joining_date: p.joining_date?.split('T')[0], custom_duty: ""});
//                       setUpdateImagePreview(p.image_url ? `${API_BASE_URL}${p.image_url}` : null);
//                       setShowUpdateForm(true);
//                       setShowPersonnelForm(false);
//                     }}>✏️ Edit</button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}
//         {/* Duty History Tab */}
//         {activeTab === 'duty-history' && (
//           <div className="quarter-section">
//             <div className="section-header">
//               <h2>Duty History</h2>
//               <button className="btn btn-primary"
//                 onClick={() => setShowDutyHistoryForm(!showDutyHistoryForm)}>
//                 {showDutyHistoryForm ? '✖ Cancel' : '+ Add'}
//               </button>
//             </div>

//             {showDutyHistoryForm && (
//               <div className="update-quarter-form">
//                 <h3>➕ Add Duty History</h3>
//                 <form onSubmit={handleAddDutyHistory}>
//                   <div className="form-grid">
//                     <div className="form-group">
//                       <label>Personnel *</label>
//                       <select value={dutyHistoryForm.personnel_id}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, personnel_id: e.target.value})} required>
//                         <option value="">-- Select --</option>
//                         {personnel.map(p => <option key={p.id} value={p.id}>{p.name} ({p.pno_no})</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Duty Type *</label>
//                       <select value={dutyHistoryForm.duty_type}
//                         onChange={(e) => {
//                           setDutyHistoryForm({
//                             ...dutyHistoryForm, 
//                             duty_type: e.target.value,
//                             duty_assignment: getDutyAssignments(e.target.value)[0] // Reset to first duty of selected type
//                           });
//                         }} required>
//                         {dutyTypes.map(t => <option key={t} value={t}>{t}</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Duty Assignment *</label>
//                       <select value={dutyHistoryForm.duty_assignment}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, duty_assignment: e.target.value})} required>
//                         {getDutyAssignments(dutyHistoryForm.duty_type).map(d => (
//                           <option key={d} value={d}>{d}</option>
//                         ))}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Location</label>
//                       <input placeholder="Police Station" value={dutyHistoryForm.location}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, location: e.target.value})} />
//                     </div>
//                     <div className="form-group">
//                       <label>Start Date *</label>
//                       <input type="date" value={dutyHistoryForm.start_date}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, start_date: e.target.value})} required />
//                     </div>
//                     <div className="form-group">
//                       <label>End Date *</label>
//                       <input type="date" value={dutyHistoryForm.end_date}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, end_date: e.target.value})} required />
//                     </div>
//                     <div className="form-group" style={{gridColumn: '1/-1'}}>
//                       <label>Remarks</label>
//                       <textarea placeholder="Notes..." value={dutyHistoryForm.remarks}
//                         onChange={(e) => setDutyHistoryForm({...dutyHistoryForm, remarks: e.target.value})} rows={3} />
//                     </div>
//                   </div>
//                   <button type="submit" className="btn btn-primary">✓ Add</button>
//                 </form>
//               </div>
//             )}

//             <div className="repair-section">
//               <h3>Records ({dutyHistory.length})</h3>
//               <div className="repair-list">
//                 {dutyHistory.map(r => (
//                   <div key={r.id} className="repair-item">
//                     <div className="repair-info">
//                       <h4>📋 {r.name} ({r.pno_no})</h4>
//                       <p><strong>Duty:</strong> {r.duty_type} - {r.duty_assignment}</p>
//                       <p><strong>Period:</strong> {formatDate(r.start_date)} to {formatDate(r.end_date)}</p>
//                       {r.location && <p><strong>Location:</strong> {r.location}</p>}
//                       {r.remarks && <p><em>{r.remarks}</em></p>}
//                     </div>
//                     <button className="btn btn-danger" onClick={() => handleDeleteDutyHistory(r.id)}>🗑️</button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Leaves Tab */}
//         {activeTab === 'leaves' && (
//           <div className="quarter-section">
//             <div className="section-header">
//               <h2>Leave Management</h2>
//               <button className="btn btn-primary"
//                 onClick={() => setShowLeaveForm(!showLeaveForm)}>
//                 {showLeaveForm ? '✖ Cancel' : '+ Add'}
//               </button>
//             </div>

//             {showLeaveForm && (
//               <div className="update-quarter-form">
//                 <h3>➕ Add Leave</h3>
//                 <form onSubmit={handleAddLeave}>
//                   <div className="form-grid">
//                     <div className="form-group">
//                       <label>Personnel *</label>
//                       <select value={leaveForm.personnel_id}
//                         onChange={(e) => setLeaveForm({...leaveForm, personnel_id: e.target.value})} required>
//                         <option value="">-- Select --</option>
//                         {personnel.map(p => <option key={p.id} value={p.id}>{p.name} ({p.pno_no})</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Leave Type *</label>
//                       <select value={leaveForm.leave_type}
//                         onChange={(e) => setLeaveForm({...leaveForm, leave_type: e.target.value})} required>
//                         {leaveTypes.map(t => <option key={t} value={t}>{t}</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group">
//                       <label>Start *</label>
//                       <input type="date" value={leaveForm.start_date}
//                         onChange={(e) => setLeaveForm({...leaveForm, start_date: e.target.value})} required />
//                     </div>
//                     <div className="form-group">
//                       <label>End *</label>
//                       <input type="date" value={leaveForm.end_date}
//                         onChange={(e) => setLeaveForm({...leaveForm, end_date: e.target.value})} required />
//                     </div>
//                     <div className="form-group">
//                       <label>Status *</label>
//                       <select value={leaveForm.status}
//                         onChange={(e) => setLeaveForm({...leaveForm, status: e.target.value})} required>
//                         {leaveStatuses.map(s => <option key={s} value={s}>{s}</option>)}
//                       </select>
//                     </div>
//                     <div className="form-group" style={{gridColumn: '1/-1'}}>
//                       <label>Reason *</label>
//                       <textarea placeholder="Reason..." value={leaveForm.reason}
//                         onChange={(e) => setLeaveForm({...leaveForm, reason: e.target.value})} required rows={3} />
//                     </div>
//                     <div className="form-group" style={{gridColumn: '1/-1'}}>
//                       <label>Remarks</label>
//                       <textarea placeholder="Admin remarks..." value={leaveForm.remarks}
//                         onChange={(e) => setLeaveForm({...leaveForm, remarks: e.target.value})} rows={2} />
//                     </div>
//                   </div>
//                   <button type="submit" className="btn btn-primary">✓ Add</button>
//                 </form>
//               </div>
//             )}

//             <div className="repair-section">
//               <h3>Leave Records ({leaves.length})</h3>
//               <div className="repair-list">
//                 {leaves.map(l => (
//                   <div key={l.id} className="repair-item">
//                     <div className="repair-info">
//                       <h4>🏖️ {l.name} ({l.pno_no})</h4>
//                       <p><strong>Type:</strong> {l.leave_type} | <span className={`status-badge ${l.status}`}>{l.status}</span></p>
//                       <p><strong>Period:</strong> {formatDate(l.start_date)} to {formatDate(l.end_date)}</p>
//                       <p><strong>Reason:</strong> {l.reason}</p>
//                       {l.remarks && <p><em>Remarks: {l.remarks}</em></p>}
//                     </div>
//                     <div className="repair-actions">
//                       {l.status === 'pending' && (
//                         <>
//                           <button className="btn btn-primary" onClick={() => handleApproveLeave(l.id)}>✓</button>
//                           <button className="btn btn-secondary" onClick={() => handleRejectLeave(l.id)}>✖</button>
//                         </>
//                       )}
//                       <button className="btn btn-danger" onClick={() => handleDeleteLeave(l.id)}>🗑️</button>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default AdminPanel;

